import React, { useEffect, useMemo, useState } from 'react';
import {  Alert } from '@mui/material';
import { Box } from '@mui/system';
import {  useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import TotalAmountLabels from './Components/TotalAmountLabels';
import EntryTable from './Components/EntryTable';
import { showErrorSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import { showSuccessSnackbar } from '../../components/snackBar/snakbar';
import InvoiceBasicDetails from './Components/InvoiceBasicDetails';
import PaymentDetails from './Components/PaymentDetails';
import DispatchDetails from './Components/DispatchDetails';
import MultiFileAttachment from './Components/MultiFileAttachment';
import Description from './Components/Description';
import Grid from '@mui/material/Grid';
import dayjs from 'dayjs';
import { API, graphqlOperation } from 'aws-amplify';
import HsnandJournalTab from './Components/HsnandJournalTab';
import {
  createSalesPosInvoiceTemp,
  createTransactionWithSpecificTime,
  deleteTransactionMaster,
  getInvoiceMasterCustom,
  getMinMaxInvoiceDate,
} from '../../graphql';
import './Components//Invoice.css';
import Loader from './Components/Loader';
import { SalesTaxablePrint } from '../../library/InvoicePrint';
import { ShareModal } from '../../components/modals/Share';
import printJS from 'print-js';

import ConfirmCancel from '../../components/modals/confirmCancel';

import PreviewSalesTaxable from '../../components/modals/PreviewSalesTaxable';
import { uploadToServer } from '../../library/upload';
import PromptInvoiceSettings from '../../components/modals/PromptInvoiceSettings';
import DraggableAction from '../../components/Buttons/DraggableAction';
import InvoiceCancel from '../../components/modals/InvoiceCancel';
import EInvAuth from './Modals/EInvAuth';
import useSaveShortcut from '../../hooks/useSaveShortcut';
import { setNavigationBlocked } from '../../redux/reducers/controllNavigation';
import { useLambdaFunctionUrl } from '../../hooks/useEmailSettingLambda';
import { useListGeneralSettingQuery, VoucherSettingsApi } from '../../redux/apis/newVoucherSettings.api';
import { useListInvoiceSettingsQuery } from '../../redux/apis/invoiceSettingsApi.api';
import { createInvoiceBatch, createInvoiceBatchWithoutImages } from '../../graphql/postgress_graphql/customMutations';
import { useCreatePdfMutation } from '../../redux/apis/createPdf.api';
import { useStateList } from './Components/HandleInvoiceStateProvider';
import { dashboardApi } from '../../redux/apis/dashboardApi';
import UseVoucherDetails from './Components/UseVoucherDetails';
import { fetchAndPrintPDF } from '../../utils/common';
import moment from 'moment';
import API_ENDPOINTS from '../../apiEndpoints';
import { useRef } from 'react';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import CancelUI from '../../components/Ui/CancelUI';
import { updateTitle } from '../../redux/reducers/titleSlice';
import { CheckVoucherValid } from './Components/CheckVoucherValid';
import { useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';
let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;

// Normalize items/nonItems arrays for comparison - only include meaningful data fields
const normalizeItemForComparison = (item) => {
  if (!item) return null;
  return {
    itemCode: item.itemCode?.value || '',
    name: item.name?.value || '',
    priceType: item.priceType?.value || 0,
    ledgerAccount: item.ledgerAccount?.value || '',
    HSN: item.HSN?.value || '',
    qty: Number(item.qty) || 0,
    units: typeof item.units === 'object' ? item.units?.value || '' : item.units || '',
    rate: Number(item.rate) || 0,
    amount: Number(item.amount) || 0,
    dicount: Number(item.dicount) || 0,
    discountType: item.discountType || 'Amount',
    discountRate: item.discountRate || '',
    taxableAMount: Number(item.taxableAMount) || 0,
    GSTRate: item.GSTRate || '',
    manualGSTFlag: item.manualGSTFlag || 0,
    taxability: item.taxability?.value || '',
    ITCFlag: item.ITCFlag || 0,
    manualDiscount: Boolean(item.manualDiscount),
    manualCess: Number(item.manualCess) || 0,
    cessType: item.cessType || 'Amount',
    cessRate: item.cessRate || '',
    autoCess: Number(item.autoCess) || 0,
    autoDiscount: Number(item.autoDiscount) || 0,
    IGST: Number(item.IGST) || 0,
    CGST: String(item.CGST || '0.00'),
    SGST: String(item.SGST || '0.00'),
    GSTCess: Number(item.GSTCess) || 0,
    netAmount: String(item.netAmount || '0000'),
    effectiveFrom: Number(item.effectiveFrom) || 0,
    effectiveTo: Number(item.effectiveTo) || 0,
    invoiceitemid: item.invoiceitemid || null,
  };
};

const normalizeNonItemForComparison = (item) => {
  if (!item) return null;
  return {
    ledgerAccount: item.ledgerAccount?.value || '',
    HSN: item.HSN?.value || '',
    description: item.description || '',
    taxableAMount: Number(item.taxableAMount) || 0,
    GSTRate: item.GSTRate || '',
    manualGSTFlag: item.manualGSTFlag || 0,
    taxability: item.taxability?.value || '',
    ITCFlag: item.ITCFlag || 0,
    manualDiscount: Boolean(item.manualDiscount),
    manualCess: Number(item.manualCess) || 0,
    cessType: item.cessType || 'Amount',
    cessRate: item.cessRate || '',
    autoCess: Number(item.autoCess) || 0,
    autoDiscount: Number(item.autoDiscount) || 0,
    IGST: Number(item.IGST) || 0,
    CGST: String(item.CGST || '0.00'),
    SGST: String(item.SGST || '0.00'),
    GSTCess: Number(item.GSTCess) || 0,
    netAmount: Number(item.netAmount) || 0,
    invoiceitemid: item.invoiceitemid || null,
  };
};

const normalizeArrayForComparison = (array, normalizer) => {
  if (!Array.isArray(array)) return [];
  return array
    .filter((item) => {
      // Filter out empty placeholder items (items with no meaningful data)
      if (normalizer === normalizeItemForComparison) {
        return item.itemCode?.value || item.name?.value || item.qty || item.rate || item.amount;
      } else {
        return item.ledgerAccount?.value || item.description || item.taxableAMount;
      }
    })
    .map(normalizer)
    .sort((a, b) => {
      // Sort by invoiceitemid if available, otherwise by index to ensure consistent comparison
      const aId = a.invoiceitemid || 0;
      const bId = b.invoiceitemid || 0;
      return aId - bId;
    });
};

function NewSalesInvoiceTaxPrime({ isVoucher, accountDetails }) {
  const [saveNew, setSaveNew] = useState(false);
  const [eWayOpen, setEwayOpen] = useState(false);
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const [connectCheckbox, setConnectCheckbox] = useState('');
  const navigate = useControlledNavigation();
  const modalRef = useRef();
  let location = useLocation();
  let eInv = useSelector((state) => state.eInvReducer);
  const params = location.state || {
    id: parseInt(new URLSearchParams(window.location.search).get('transaction')),
    view: parseInt(new URLSearchParams(window.location.search).get('transaction')) ? true : false,
    pdflink: new URLSearchParams(window.location.search).get('pdflink') || '',
  };
  dispatch(display());
  const einvState = location?.state?.eImp;
  console.log(einvState, 'einvState');
  useEffect(() => {
    if (einvState === true) {
      setEImp(true);
    }
  }, [einvState]);
  const { Enable_CreditPeriod, Enable_ItemWiseEntry } = useSelector((state) => state.paymentSettingsReducer);
  const userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  const { data: companyPreference } = useListCompanyPreferenceQuery();
  const salesPref = companyPreference?.find((pref) => pref.attributetypecd === 'SalesPrint');
  const isSalesShow = salesPref?.attributevalue || 0;

  const postingDatePref = companyPreference?.find(
    (p) =>
      p.attributetypecd === 'MyPostingDate' &&
      String(p?.additionalvalue ?? '') === String(userPreferece?.financialYear?.financialyearid ?? '')
  );
  const currentPostingDate = postingDatePref?.attributevalue;
  const [savedPostingDate, setSavedPostingDate] = useState('');

  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;
  const { data: generalSettings } = useListGeneralSettingQuery(
    {
      entrytypecd: 'SalesInvoice',
      financialyearid: userPreferece?.financialYear?.financialyearid,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
   
  const voucherFlag = generalSettings?.find((item) => item.expiredtimestamp === 0)?.nextinvoicenumber;
  const {
    data: InvoiceSettingsList,
    isLoading: InvoiceSettingsListLoading,
    isError: InvoiceSettingsListError,
    isFetching: InvoiceFetching,
  } = useListInvoiceSettingsQuery(
    { type: 'ALL' },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const InvoiceSettings = useMemo(() => {
    if (!InvoiceSettingsList) return [];
    return InvoiceSettingsList.find((e) => e.typecd == 'RegularSettings');
  }, [InvoiceSettingsList]);
  const newItemObj = {
    itemCode: { label: '', value: '' },
    name: { label: '', value: '' },
    priceType: { label: '', value: '' },
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    qty: 0,
    units: '',
    rate: 0,
    amount: 0,
    dicount: 0,
    taxableAMount: 0,
    GSTRate: '',
    manualGSTFlag: 0,
    taxability: { label: '', value: '' },
    manualDiscount: false,
    manualCess: false,
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: '0000',
    editable: true,
    new: true,
  };
  const newNonItemObj = {
    ledgerAccount: { label: '', value: '' },
    HSN: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    description: '',
    taxableAMount: 0,
    GSTRate: '',
    manualGSTFlag: 0,
    taxability: { label: '', value: '' },
    manualDiscount: false,
    manualCess: false,
    autoCess: 0,
    autoDiscount: 0,
    IGST: 0,
    expiredtimestamp: 0,
    CGST: '0.00',
    SGST: '0.00',
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  };
  const [createPdf, progress] = useCreatePdfMutation();
  const [eInvAuthModalProps, setEInvAuthModalProps] = useState({ open: false });
  const {
    initialState,
    setInitialState,
    data,
    setData,
    invID,
    setInvID,
    cancelModal,
    setCancelModal,
    state,
    setState,
    cancelModalStatus,
    setCancelModalStatus,
    itemData,
    setItemData,
    deleteModalStatus,
    setDeleteModalStatus,
    eImp,
    setEImp,
    eWayImp,
    viewMode,
    setViewMode,
    setPaymentAccordion,
    invoiceEntry,
    setInvoiceEntry,
    totTaxAmt,
    totDiscount,
    totGSTCess,
    totNetAmt,
    totGST,
    totAmt,
    companyState,
    itemType,
    netAmountToPay,
    companyData,
    partyDeliveryAddressEntity,
    partyBillAddressEntity,
    invTransArr,
    paymentTransArr,
    itemsRows,
    initialAttachments,
    transGeneralSettingsFlag,
    partyNameOptions,
    partyAccountID,
    linkedTransArr,
    voucherArr,
    transVoucherArr,
    paymentTransID,
    currentVoucherNo,
    backdropOpen,
    setBackdropOpen,
    units,
    setLastInvoiceDate,
    setFirstInvoiceDate,
    setNextInvoiceDate,
    setPosition,
    isDragging,
    setIsDragging,
    offset,
    registrationType,
    setTabValue,
    setItemValid,
    setNonItemValid,
    partyType,
    tableErrArr,
    setTableErrArr,
    items,
    setItems,
    nonItems,
    setNonItems,
    billingAddressDetails,
    deliveryAddressDetails,
    initItemTableDta,
    initNonItemTableData,
    previewSalesTaxableModal,
    setPreviewSalesTaxableModal,
    selected,
    setSelected,
    setATags,
    deletedItems,
    deletedNonItems,
    currentDouments,
    resetData,
    resetItems,
    resetNonItems,
    setItemsRows,
    firstInvoiceDate,
    lastInvoiceDate,
    nextInvoiceDate,
    generalSettingsFlag,
  } = useStateList();
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;

  const EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;
  const isCessFlag= params?.id?params?.cessexist:getCompany?.relatedcompanydetailsnew?.[0]?.gstcompensationcessflag;

  function isEmptyDeliveryAddress(details) {
    const { deliveryAddress, states, district, country, pincode, stateCD, countryCD, districtCD, gstin, customerName } = details;

    const isEmptyVal = (val) => {
      if (val === null || val === undefined) return true;
      if (typeof val === 'string') return val.trim() === '' || val === '0';
      if (typeof val === 'object') {
        return Object.values(val).every((v) => v === '' || v === null || v === undefined || v === '0');
      }
      return false;
    };

    return (
      isEmptyVal(deliveryAddress) &&
      isEmptyVal(states?.value) &&
      isEmptyVal(district?.value) &&
      isEmptyVal(country?.value) &&
      isEmptyVal(pincode) &&
      isEmptyVal(stateCD) &&
      isEmptyVal(countryCD) &&
      isEmptyVal(districtCD) &&
      isEmptyVal(gstin) &&
      isEmptyVal(customerName)
    );
  }

  const isConsigneeEmpty = data?.consigneeName === '' || data?.consigneeGST === '';
  const isEmptyInvDeliveryAddress = isEmptyDeliveryAddress(deliveryAddressDetails);
  const isEmptyPartyDelivery =
    !partyDeliveryAddressEntity ||
    (Object.keys(partyDeliveryAddressEntity).length === 0 && partyDeliveryAddressEntity.constructor === Object);
  const isAdrressEmpty = !isEmptyInvDeliveryAddress || !isEmptyPartyDelivery || !isConsigneeEmpty;
  function isEmptyBillingAddress(details) {
  const {
    billingAddress,
    states,
    district,
    country,
    city,
    pincode,
    stateCD,
    countryCD,
    districtCD,
    gstin,
    customerName,
  } = details || {};

  const isEmptyVal = (val) => {
    if (val === null || val === undefined) return true;

    if (typeof val === 'string') {
      return val.trim() === '' || val === '0';
    }

    if (typeof val === 'object') {
      return Object.values(val).every(
        (v) => v === '' || v === null || v === undefined || v === '0'
      );
    }

    return false;
  };

  return (
    isEmptyVal(billingAddress) &&
    isEmptyVal(states?.value) &&
    isEmptyVal(district?.value) &&
    isEmptyVal(country?.value) &&
    isEmptyVal(city?.value) &&
    isEmptyVal(pincode) &&
    isEmptyVal(stateCD) &&
    isEmptyVal(countryCD) &&
    isEmptyVal(districtCD) &&
    isEmptyVal(gstin) &&
    isEmptyVal(customerName)
  );
}

  const isBillAddressEmpty=Object.keys(partyBillAddressEntity).length === 0 && isEmptyBillingAddress(billingAddressDetails);

  const endDrag = () => setIsDragging(false);
  useEffect(() => {
    const onDrag = (e) => {
      if (!isDragging) return;
      let newY = e.clientY - offset.y;
      let newX = e.clientX - offset.x;
      newY = Math.max(300, newY);
      newY = Math.min(640, newY);
      newX = Math.max(100, newX);
      newX = Math.min(1445, newX);
      setPosition((prevPosition) => ({
        ...prevPosition,
        y: newY,
        x: newX,
      }));
    };

    if (isDragging) {
      window.addEventListener('mousemove', onDrag);
      window.addEventListener('mouseup', endDrag);
      return () => {
        window.removeEventListener('mousemove', onDrag);
        window.removeEventListener('mouseup', endDrag);
      };
    }
  }, [isDragging, offset.x, offset.y]);

  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);

  useEffect(() => {
    setATags(document.getElementsByTagName('a').length);
    if (selectorDrawer == true) {
      setTimeout(() => {
        setATags(document.getElementsByTagName('a').length);
      }, 50);
    }
  }, [selectorDrawer, selector]);

  const [isDirty, setIsDirty] = useState(false);
  const itemsBaselineRef = useRef(null);
  const nonItemsBaselineRef = useRef(null);
  const baselineInitializedRef = useRef(false);

  // Update Redux title whenever voucher number changes (for breadcrumbs)
  useEffect(() => {
    if (data?.voucherNumber) {
      dispatch(updateTitle(data.voucherNumber));
    }

    if (params.view) {
      dispatch(setNavigationBlocked(false));
      return;
    }

    const isEdit = Boolean(params?.id && !isNaN(params.id));
    const isDataLoaded = !backdropOpen;

    if (!baselineInitializedRef.current && isDataLoaded) {
      if (isEdit) {
        if (invoiceEntry && Object.keys(invoiceEntry).length > 0) {
          // Normalize baseline data for comparison
          const normalizedInitItems = normalizeArrayForComparison(initItemTableDta || [], normalizeItemForComparison);
          const normalizedInitNonItems = normalizeArrayForComparison(initNonItemTableData || [], normalizeNonItemForComparison);
          itemsBaselineRef.current = JSON.stringify(normalizedInitItems);
          nonItemsBaselineRef.current = JSON.stringify(normalizedInitNonItems);
          baselineInitializedRef.current = true;
        }
      } else {
        // Normalize current data for baseline
        const normalizedItems = normalizeArrayForComparison(items || [], normalizeItemForComparison);
        const normalizedNonItems = normalizeArrayForComparison(nonItems || [], normalizeNonItemForComparison);
        itemsBaselineRef.current = JSON.stringify(normalizedItems);
        nonItemsBaselineRef.current = JSON.stringify(normalizedNonItems);
        baselineInitializedRef.current = true;
      }
    }

    if (!baselineInitializedRef.current) {
      dispatch(setNavigationBlocked(false));
      return;
    }

    const isDataModified = JSON.stringify(data) !== JSON.stringify(initialState);

    // Normalize current items/nonItems for comparison
    const normalizedCurrentItems = normalizeArrayForComparison(items || [], normalizeItemForComparison);
    const normalizedCurrentNonItems = normalizeArrayForComparison(nonItems || [], normalizeNonItemForComparison);
    const currentItemsStr = JSON.stringify(normalizedCurrentItems);
    const currentNonItemsStr = JSON.stringify(normalizedCurrentNonItems);

    const isItemsModified = itemsBaselineRef.current
      ? currentItemsStr !== itemsBaselineRef.current
      : false;

    const isNonItemsModified = nonItemsBaselineRef.current
      ? currentNonItemsStr !== nonItemsBaselineRef.current
      : false;

    const isAttachmentsModified = itemsRows.length !== initialAttachments.length;

    const shouldBeDirty = isDataModified || isItemsModified || isNonItemsModified || isAttachmentsModified;

    if (shouldBeDirty !== isDirty) {
      setIsDirty(shouldBeDirty);
    }
  }, [
    dispatch,
    params.view,
    params.id,
    data,
    items,
    nonItems,
    itemsRows,
    initialState,
    initialAttachments,
    initItemTableDta,
    initNonItemTableData,
    backdropOpen,
    invoiceEntry,
    isDirty,
  ]);

  useEffect(() => {
    dispatch(setNavigationBlocked(isDirty));
  }, [isDirty, dispatch]);

  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);

  const { callLambdaFunctionUrl, loading, error } = useLambdaFunctionUrl();

  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    }
  }, []);
  function formVaidation(objData) {
    let isvalid = true;
    let errorArr = [];
    console.log("data",data);
    
    let obj = { ...data };
    Object.keys(objData).map((itemKey) => {
      if (itemKey === 'partyName') {
        if (objData[itemKey]?.label == '') {
          isvalid = false;
          obj.errorFields.partyName = 'Customer Name is required';
          obj.errorStatus.partyName = true;
          errorArr.push('Customer Name');
        } else {
          obj.errorFields.partyName = '';
          obj.errorStatus.partyName = false;
        }
      }

      if (itemKey === 'seriesVouchers') {
        if (objData[itemKey]?.value === '') {
          isvalid = false;
          obj.errorFields.seriesVouchers = 'Invoice Series Name is Required';
          obj.errorStatus.seriesVouchers = true;
          errorArr.push('Invoice Series Name');
        } else {
          obj.errorFields.seriesVouchers = '';
          obj.errorStatus.seriesVouchers = false;
        }
      }
      if (itemKey === 'currencyRate') {
        if (objData[itemKey] === 0 || objData[itemKey] === '') {
          isvalid = false;
          obj.errorStatus.currencyRate = true;
          setTabValue('2');
          showWarningSnackbar('Please enter the Currency Rate');
          errorArr.push('Currency Rate');
        } else {
          obj.errorFields.currencyRate = '';
          obj.errorStatus.currencyRate = false;
        }
      }
      if (itemKey === 'invoiceDate') {
        const startDate = userPreferece.financialYear.startdate * 1000;
        const endDate = userPreferece.financialYear.enddate * 1000;

        const minDate = moment(params?.id && !isNaN(params.id) ? firstInvoiceDate || startDate : lastInvoiceDate || startDate);

        const maxDate = moment(params?.id && !isNaN(params.id) ? nextInvoiceDate || endDate : endDate);

        if (!objData[itemKey]?.trim()) {
          isvalid = false;
          obj.errorFields.invoiceDate = 'Invoice Date is required';
          obj.errorStatus.invoiceDate = true;
          errorArr.push('Invoice Date');
        } else if (moment(objData[itemKey], 'YYYY-MM-DD').isBefore(minDate) || moment(objData[itemKey], 'YYYY-MM-DD').isAfter(maxDate)) {
          isvalid = false;
          obj.errorFields.invoiceDate = `Invoice Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format(
            'DD MMM YYYY'
          )}`;
          showWarningSnackbar(`Invoice Date must be between ${minDate.format('DD MMM YYYY')} and ${maxDate.format('DD MMM YYYY')}`);
          obj.errorStatus.invoiceDate = true;
        } else {
          obj.errorFields.invoiceDate = '';
          obj.errorStatus.invoiceDate = false;
        }
      }

      if (itemKey === 'customerOrderDate') {
        if (objData[itemKey] && isNaN(moment(objData[itemKey]))) {
          isvalid = false;
          obj.errorStatus.customerOrderDate = true;
          obj.errorFields.customerOrderDate = 'Invalid date format';
        }
        //  else if (moment(objData[itemKey]) > moment(data?.invoiceDate)) {
        //   isvalid = false;
        //   obj.errorStatus.customerOrderDate = true;
        //   obj.errorFields.customerOrderDate = 'Customer Order Date cannot be greater than Invoice Date';
        //   showWarningSnackbar('Customer Order Date cannot be greater than Invoice Date');
        // } 
        else {
          obj.errorFields.customerOrderDate = '';
          obj.errorStatus.customerOrderDate = false;
        }
      }

      if (registrationType != 1) {
        if (itemKey === 'taxability') {
          if (objData[itemKey].value === '') {
            isvalid = false;
            obj.errorFields.taxability = 'Taxability is required';
            obj.errorStatus.taxability = true;
            errorArr.push('Taxability');
          } else {
            obj.errorFields.taxability = '';
            obj.errorStatus.taxability = false;
          }
        }
      }

      if (itemKey === 'paymentType') {
        if (objData[itemKey]?.trim()?.length <= 0) {
          isvalid = false;
          obj.errorFields.paymentType = 'Payment Type is Required';
          obj.errorStatus.paymentType = true;
        } else {
          obj.errorFields.paymentType = '';
          obj.errorStatus.paymentType = false;
        }
      }

      if (itemKey === 'receivedAmount') {
        if (objData['paymentType'] == 'Cash' || objData['paymentType'] == 'Bank') {
          if (objData[itemKey] == 0 || isNaN(Number(objData[itemKey]))) {
            isvalid = false;
            obj.errorFields.receivedAmount = 'Received Amount is Required';
            obj.errorStatus.receivedAmount = true;
            setPaymentAccordion(true);
          } else if (Number(netAmountToPay) < Number(data.receivedAmount)) {
            isvalid = false;
            obj.errorFields.receivedAmount = 'Amount should be less than Grand Total';
            obj.errorStatus.receivedAmount = true;
            setPaymentAccordion(true);
          } else {
            obj.errorFields.receivedAmount = '';
            obj.errorStatus.receivedAmount = false;
          }
        }
      }

      if (itemKey === 'receivedAccount') {
        if (objData['paymentType'] == 'Cash' || objData['paymentType'] == 'Bank') {
          if (objData[itemKey].value == '') {
            isvalid = false;
            obj.errorFields.receivedAccount = 'Received Account is Required';
            obj.errorStatus.receivedAccount = true;
            setPaymentAccordion(true);
          } else {
            obj.errorFields.receivedAccount = '';
            obj.errorStatus.receivedAccount = false;
          }
        }
      }

      if (itemKey === 'creditPeriod') {
        if (objData['paymentType'] == 'Credit') {
          if (objData[itemKey] > 1000 || objData[itemKey] < 0) {
            isvalid = false;
            obj.errorFields.creditPeriod = 'Credit period should between 0 and 1000';
            obj.errorStatus.creditPeriod = true;
            showWarningSnackbar('Credit period should between 0 and 1000');
            setPaymentAccordion(true);
          } else {
            obj.errorFields.creditPeriod = '';
            obj.errorStatus.creditPeriod = false;
          }
        }
      }

      if (itemKey === 'adjustments') {
        if (!new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(objData[itemKey]) && objData[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.adjustments = 'Invalid Amount Format';
          obj.errorStatus.adjustments = true;
        } else {
          obj.errorFields.adjustments = '';
          obj.errorStatus.adjustments = false;
        }
      }

      if (itemKey === 'placeOfSupply') {
        if (objData[itemKey].value?.length <= 0) {
          isvalid = false;
          obj.errorFields.placeOfSupply = 'Place Of Supply is Required';
          obj.errorStatus.placeOfSupply = true;
          errorArr.push('Place Of Supply');
        } else {
          obj.errorFields.placeOfSupply = '';
          obj.errorStatus.placeOfSupply = false;
        }
      }

      if (itemKey === 'bankReferenceNo') {
        if (objData['paymentType'] === 'Bank') {
          if (!new RegExp(/^\d{9,18}$/).test(objData[itemKey]) && objData[itemKey]?.trim().length > 0) {
            isvalid = false;
            obj.errorFields.bankReferenceNo = 'Invalid Bank/UPI Reference number';
            obj.errorStatus.bankReferenceNo = true;
          } else {
            obj.errorFields.bankReferenceNo = '';
            obj.errorStatus.bankReferenceNo = false;
          }
        }
      }
      // if(Number(voucherFlag)===-1 || invoiceEntry?.serialnumber===""){
      if (
  (!params?.id && Number(voucherFlag) === -1) ||
  (params?.id && invoiceEntry?.serialnumber === "")
) {
  


      if (itemKey === 'voucherNumber') {
        const { valid, message } = CheckVoucherValid(objData[itemKey], 'Invoice Number');
        if (objData[itemKey]?.trim()?.length <= 0) {
          isvalid = false;
          obj.errorFields.voucherNumber = 'Invoice Number is Required';
          obj.errorStatus.voucherNumber = true;
          errorArr.push('Invoice Number');
        } else if (!valid) {
          isvalid = false;
          obj.errorFields.voucherNumber = message;
          obj.errorStatus.voucherNumber = true;
          showWarningSnackbar(message);
        } else {
          let valid = true;
          voucherArr.map((ele) => {
            if (ele.InvoiceNumber !== invoiceEntry.InvoiceNumber) {
              if (ele.VoucherNumber === data.voucherNumber) {
                valid = false;
              }
            }
          });
          if (valid == false) {
            isvalid = false;
            obj.errorFields.voucherNumber = 'Invoice Number already exists';
            obj.errorStatus.voucherNumber = true;
          } else {
            obj.errorFields.voucherNumber = '';
            obj.errorStatus.voucherNumber = false;
          }
        }
      }
    }

      if (data.paymentType !== 'Credit') {
        if (itemKey === 'transactionVoucher') {
          if (objData[itemKey]?.trim().length <= 0) {
            isvalid = false;
            obj.errorFields.transactionVoucher = 'Voucher Number is Required';
            obj.errorStatus.transactionVoucher = true;
          } else {
            let valid = true;
            transVoucherArr.map((ele) => {
              if (ele.VoucherNumber !== currentVoucherNo)
                if (ele.VoucherNumber === data.transactionVoucher) {
                  valid = false;
                }
            });

            if (valid == false) {
              isvalid = false;
              obj.errorFields.transactionVoucher = 'Voucher Number already exists';
              obj.errorStatus.transactionVoucher = true;
            } else {
              obj.errorFields.transactionVoucher = '';
              obj.errorStatus.transactionVoucher = false;
            }
          }
        }
      }

      if (itemKey === 'remarks') {
        if (objData[itemKey]?.trim()?.length > 250 && objData[itemKey]?.trim()?.length > 0) {
          isvalid = false;
          obj.errorFields.remarks = 'Description must be less than 250 characters';
          obj.errorStatus.remarks = true;
        } else {
          obj.errorFields.remarks = '';
          obj.errorStatus.remarks = false;
        }
      }
    });

    setData(obj);
    const validErrors = errorArr.filter((e) => !!e && e.trim?.().length > 0);

    if (!isvalid) {
      if (validErrors.length === 1) {
        showWarningSnackbar(`${validErrors[0]} is required`);
      } else if (validErrors.length > 1) {
        const lastField = validErrors.pop();
        const errorText = `${validErrors.join(', ')} and ${lastField} are required`;
        showWarningSnackbar(errorText);
      }
    }
    if (isvalid) {
      if (Number(totTaxAmt + totGST + totGSTCess) > 99999999999) {
        showWarningSnackbar(`Total Net Amount must be less than ${data?.currency?.sign}1,000 crore.`);
        isvalid = false;
      }
    }
    return isvalid;
  }
  

  // function checkEwayBillAddress() {
  //   if (!eWayImp && !eImp) return true;

  //   const isPresent = (v) => {
  //     if (v == null) return false;
  //     if (typeof v === 'string') return v.trim().length > 0;
  //     if (typeof v === 'object') {
  //       const label = v.label ? v.label.trim() : '';
  //       const value = v.value ? v.value.trim() : '';
  //       const code = v.code ? v.code.trim() : '';
  //       return !!(label || value || code);
  //     }
  //     return !!v;
  //   };

  //   const anyKeyPresent = (obj, keys) => keys.some((k) => isPresent(obj?.[k]));

  //   const FIELDS_MAP = {
  //     Billing: [
  //       { keys: ['billingAddress', 'addressLine', 'address'], label: 'Address Details' },
  //       { keys: ['district', 'districtName'], label: 'District' },
  //       { keys: ['pincode', 'pinCode', 'postalCode', 'zip', 'zipcode'], label: 'Pincode' },
  //       { keys: ['states', 'state', 'province'], label: 'State' },
  //       { keys: ['city', 'town'], label: 'City' },
  //       { keys: ['country'], label: 'Country' },
  //     ],
  //     Shipping: [
  //       { keys: ['deliveryAddress', 'shippingAddress', 'address'], label: 'Address Details' },
  //       { keys: ['district', 'districtName'], label: 'District' },
  //       { keys: ['pincode', 'pinCode', 'postalCode', 'zip', 'zipcode'], label: 'Pincode' },
  //       { keys: ['states', 'state', 'province'], label: 'State' },
  //       { keys: ['city', 'town'], label: 'City' },
  //       { keys: ['country'], label: 'Country' },
  //     ],
  //   };

  //   const getMissingLabels = (details, type) =>
  //     FIELDS_MAP[type].filter(({ keys }) => !anyKeyPresent(details, keys)).map(({ label }) => label);

  //   const fmt = (arr) => arr.join(', ');
  //   const isAllMissingOrOnlyCountry = (missing) => missing.length === 6 || (missing.length === 5 && !missing.includes('Country'));
  //   const missingBilling = getMissingLabels(billingAddressDetails, 'Billing');
  //   const missingShipping = getMissingLabels(deliveryAddressDetails, 'Shipping');

  //   const messages = [];

  //   if (eWayImp) {
  //     const billingAll = isAllMissingOrOnlyCountry(missingBilling);
  //     const shippingAll = isAllMissingOrOnlyCountry(missingShipping);

  //     if (billingAll && shippingAll) {
  //       messages.push('Add Billing Address & Ship To Address to proceed with E-Way Bill creation');
  //     } else if (billingAll && missingShipping.length === 0) {
  //       messages.push('Add Billing Address to proceed with E-Way Bill creation');
  //     } else if (shippingAll && missingBilling.length === 0) {
  //       messages.push('Add Ship To Address to proceed with E-Way Bill creation');
  //     } else {
  //       const hasBilling = missingBilling.length > 0;
  //       const hasShipping = missingShipping.length > 0;

  //       if (hasBilling && hasShipping) {
  //         messages.push(
  //           `Fill ${fmt(missingBilling)} in Billing Address, Fill ${fmt(
  //             missingShipping
  //           )} in Ship To Address to proceed with E-Way Bill creation`
  //         );
  //       } else if (hasBilling) {
  //         messages.push(`Fill ${fmt(missingBilling)} in Billing Address to proceed with E-Way Bill creation`);
  //       } else if (hasShipping) {
  //         messages.push(`Fill ${fmt(missingShipping)} in Ship To Address to proceed with E-Way Bill creation`);
  //       }
  //     }
  //   }

  //   if (eImp && !eWayImp) {
  //     if (isAllMissingOrOnlyCountry(missingBilling)) {
  //       messages.push('Add Billing Address to proceed with E-Invoice creation');
  //     } else if (missingBilling.length > 0) {
  //       messages.push(`Fill ${fmt(missingBilling)} in Billing Address to proceed with E-Invoice creation`);
  //     }
  //   }

  //   if (messages.length) {
  //     showWarningSnackbar(messages.join('\n'));
  //     return false;
  //   }
  //   return true;
  // }
function checkEwayBillAddress() {
  if (!eWayImp && !eImp) return true;

  const isPresent = (v) => {
    if (v == null) return false;
    if (typeof v === 'string') return v.trim().length > 0;
    if (typeof v === 'object') {
      const label = v.label ? v.label.trim() : '';
      const value = v.value ? v.value.trim() : '';
      const code = v.code ? v.code.trim() : '';
      return !!(label || value || code);
    }
    return !!v;
  };

  const anyKeyPresent = (obj, keys) => keys.some((k) => isPresent(obj?.[k]));

  const FIELDS_MAP = {
    Billing: [
      { keys: ['billingAddress', 'addressLine', 'address'], label: 'Address Details' },
      { keys: ['district', 'districtName'], label: 'District' },
      { keys: ['pincode', 'pinCode', 'postalCode', 'zip', 'zipcode'], label: 'Pincode' },
      { keys: ['states', 'state', 'province'], label: 'State' },
      { keys: ['city', 'town'], label: 'City' },
      { keys: ['country'], label: 'Country' },
    ],
    Shipping: [
      { keys: ['deliveryAddress', 'shippingAddress', 'address'], label: 'Address Details' },
      { keys: ['district', 'districtName'], label: 'District' },
      { keys: ['pincode', 'pinCode', 'postalCode', 'zip', 'zipcode'], label: 'Pincode' },
      { keys: ['states', 'state', 'province'], label: 'State' },
      { keys: ['city', 'town'], label: 'City' },
      { keys: ['country'], label: 'Country' },
    ],
  };

  const getMissingLabels = (details, type, limitedFields = null) => {
    const fieldsToCheck = limitedFields || FIELDS_MAP[type];
    return fieldsToCheck.filter(({ keys }) => !anyKeyPresent(details, keys)).map(({ label }) => label);
  };

  const fmt = (arr) => arr.join(', ');
  const isAllMissingOrOnlyCountry = (missing) => missing.length === 6 || (missing.length === 5 && !missing.includes('Country'));

  let missingBilling, missingShipping;

  if (eImp && !eWayImp) {
    const isForeignInvoice = billingAddressDetails?.country !== 'IndiaState';
    if (isForeignInvoice) {
      const LIMITED_BILLING_FIELDS = FIELDS_MAP.Billing.filter((f) =>
        ['Address Details', 'City', 'Country'].includes(f.label)
      );
      missingBilling = getMissingLabels(billingAddressDetails, 'Billing', LIMITED_BILLING_FIELDS);
    } else {
      missingBilling = getMissingLabels(billingAddressDetails, 'Billing');
    }
    missingShipping = [];
  } else {
    missingBilling = getMissingLabels(billingAddressDetails, 'Billing');
    missingShipping = getMissingLabels(deliveryAddressDetails, 'Shipping');
  }

  const messages = [];

  if (eWayImp) {
    const billingAll = isAllMissingOrOnlyCountry(missingBilling);
    const shippingAll = isAllMissingOrOnlyCountry(missingShipping);

    if (billingAll && shippingAll) {
      messages.push('Add Billing Address & Ship To Address to proceed with E-Way Bill creation');
    } else if (billingAll && missingShipping.length === 0) {
      messages.push('Add Billing Address to proceed with E-Way Bill creation');
    } else if (shippingAll && missingBilling.length === 0) {
      messages.push('Add Ship To Address to proceed with E-Way Bill creation');
    } else {
      const hasBilling = missingBilling.length > 0;
      const hasShipping = missingShipping.length > 0;

      if (hasBilling && hasShipping) {
        messages.push(
          `Fill ${fmt(missingBilling)} in Billing Address, Fill ${fmt(
            missingShipping
          )} in Ship To Address to proceed with E-Way Bill creation`
        );
      } else if (hasBilling) {
        messages.push(`Fill ${fmt(missingBilling)} in Billing Address to proceed with E-Way Bill creation`);
      } else if (hasShipping) {
        messages.push(`Fill ${fmt(missingShipping)} in Ship To Address to proceed with E-Way Bill creation`);
      }
    }
  }

  if (eImp && !eWayImp) {
    if (missingBilling.length > 0) {
      messages.push(`Fill ${fmt(missingBilling)} in Billing Address to proceed with E-Invoice creation`);
    }
  }

  if (messages.length) {
    showWarningSnackbar(messages.join('\n'));
    return false;
  }
  return true;
}


  const ewayNav = (data, id, partyId, saveNew) => {
    navigate('/addewaybill', {
      state: {
        invoice: {
          docDate: dayjs(data.invoiceDate).format('DD/MM/YYYY'),
          id,
          invoiceNo: data.voucherNumber,
          // irn: data.irn,
          placeofsupply: data.value,
          supply: 'O',
          partyId,
          invoiceType: 'SalesInvoice',
        },
        connect: 'invoice',
        from: location.pathname,
        saveNew,
      },
    });
  };
  function showEInvAuthModal(connectCheckbox) {
    setBackdropOpen(false);
    return new Promise((resolve) => {
      setConnectCheckbox(connectCheckbox);
      setEInvAuthModalProps({
        open: true,
        onComplete: (result) => resolve(result),
      });
    });
  }
  function checkPriceTypeWithInvDate(value) {
    const updatedTableArr = [...items];
    let isValid = true;

    const momentInvoiceDate = moment(value, 'YYYY-MM-DD');
    updatedTableArr.forEach((subele) => {
      if (subele?.effectiveFrom !== 0) {
        const tempEffectiveFrom = moment(subele.effectiveFrom * 1000).startOf('day');
        const tempEffectiveTo =
          subele.effectiveTo === '' || subele?.effectiveTo === 0 ? null : moment(subele.effectiveTo * 1000).startOf('day');

        const normalizedInvoiceDate = moment(momentInvoiceDate).startOf('day');
        const isOutsideRange =
          normalizedInvoiceDate.isBefore(tempEffectiveFrom) || (tempEffectiveTo && normalizedInvoiceDate.isAfter(tempEffectiveTo));

        if (isOutsideRange) {
          isValid = false;
          subele.invalidDate = true;
        } else {
          subele.invalidDate = false;
        }
      }
    });

    if (!isValid) {
      showWarningSnackbar('The highlighted items do not match the invoice date range. Please verify the effective dates.');
    }
    return isValid;
  }
  async function getInvoiceMasterData(data) {
    try {
      const res = await API.graphql(graphqlOperation(getInvoiceMasterCustom, { invoiceid: data }));
      if (res.data.getInvoiceMaster !== null) {
        const invoiceData = res.data.getInvoiceMaster[0];
        setInvoiceEntry(invoiceData);
        setSavedPostingDate(invoiceData?.invoicedate);
        
        // Update Redux title with invoice number from loaded sales invoice
        if (invoiceData?.invoicenumber) {
          dispatch(updateTitle(invoiceData.invoicenumber));
        }
        
        // setBackdropOpen(false);
      } else {
        setSavedPostingDate('');
        setData((prev) => ({
          ...prev,
          invoiceDate: '',
        }));
      }

      // if (eInv.preview === true) {
      //   setPreviewSalesTaxableModal(true);
      //   // dispatch(einvPreview(true));
      // }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  console.log(invoiceEntry, 'invoiceEntry');
  async function savePaymentDetails(invID) {
    try {
      let masterArr = [];
      let linkedArr = [];
      const comments = data.remarks.split('\n');
      let currentLinkedArr = [];
      let tranSDetailsArr = [];
      if (data.paymentType !== 'Credit') {
        const masterData = {
          bankreferencenumber: data.bankReferenceNo,
          comments: comments?.join('**'),
          entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          transactiontypecd: data.paymentType == 'Cash' ? 'CashReceipt' : data.paymentType == 'Bank' ? 'BankReceipt' : 'Credit',
          vouchercode: transGeneralSettingsFlag === -1 ? data.transactionVoucher : '',
          serialnumber: data.transactionSeries.value,
          cancelflag: 0,
        };
        masterArr.push(masterData);

        paymentTransArr.map((ele, index) => {
          const paymentTransDetails = {
            accountid: ele.accID,
            comments: comments?.join('**'),
            creditamount: Number(ele.creditAmt),
            debitamount: Number(ele.debitAmt),
            entryordernumber: index + 1,

            transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
            cancelflag: 0,
          };
          tranSDetailsArr.push(paymentTransDetails);
        });

        const linkCurrentPayment = {
          linkedamount: Number(data.receivedAmount),
          transactiontypecd: 'SalesInvoice',
          isdirect: 1,
          objectattribute: data.voucherNumber,
          objectid: invID,
          objecttype: data.paymentType,
          accountid: partyAccountID,
          paymentvouchernumber: data?.transactionVoucher,
        };
        linkedArr.push(linkCurrentPayment);
        linkedTransArr.map(async (ele) => {
          let linkTransData = {
            linkedamount: Number(ele.linkedamount),
            transactiontypecd: 'SalesInvoice',
            isdirect: 0,
            objectattribute: data?.voucherNumber,
            objectid: invID,
            objecttype: ele.transactiontypecd,
            transactionid: ele.transactionid,
            accountid: partyAccountID,
            paymentvouchernumber: data?.transactionVoucher,
          };
          linkedTransArr.push(linkTransData);
        });
        const result = await API.graphql(
          graphqlOperation(createTransactionWithSpecificTime, {
            transactionmaster: JSON.stringify(masterArr),
            transactiondetails: JSON.stringify(tranSDetailsArr),
            transactionattachment: JSON.stringify([]),
            transactiontdsdetails: JSON.stringify([]),
            transactionrelation: JSON.stringify(linkedArr),
            mode: 1,
            transactiontcsdetails: JSON.stringify([]),
          })
        );
        let url = path + `Invoices/Receipt/Ledgerx_Receipt_${data.transactionVoucher}.pdf`;
        await createPdf({
          path: url,
          type: 'receipt',
          transactionid: result.data?.createTransactionWithSpecificTime?.transactionid,
        });
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }

  let url = path + `Invoices/Sales/Ledgerx_Sales_Invoice_${params?.id?invoiceEntry?.invoicenumber:data?.voucherNumber}.pdf`;
  let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${url}`;

  async function saveChanges(obj) {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };

    if (formVaidation(formData)) {
      setBackdropOpen(true);

      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;
       let url = path + `Invoices/Sales/Ledgerx_Sales_Invoice_${data.voucherNumber===""?String(data.seriesVouchers.label):String(data.voucherNumber)}.pdf`;
       let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${url}`;
       console.log("url",url);
       

      updatedTableItemRow.map((ele, ind) => {
        if (ele?.itemCode?.value !== '') {
          if (ele?.itemCode?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemCode' + ind);
            requireds.push('Item Code');
          }
          if (ele?.name?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemName' + ind);
            requireds.push('Item Name');
          }
          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                itemValid = false;
                requireds.push('GST Rate');
                errorArr.push('GSTRate' + ind);
              }
            }
          }
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            // partyType === 'CUSTOMER'
            companyType === 2 &&
            partyType === 'CUSTOMER'
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push('hsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }

          if (!EInvoiceFlag && itemType === 'GOODS') {
            if (ele?.qty == 0 || ele?.qty === '') {
              isvalid = false;
              itemValid = false;
              errorArr.push('qty' + ind);
              requireds.push('Quantity');
            }
          }
          if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
            isvalid = false;
            itemValid = false;
            invalids.push(' Quantity');
          }
          if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push('Rate');
            errorArr.push('rate' + ind);
          }

          if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
            isvalid = false;
            itemValid = false;
            errorArr.push('dicount' + ind);
            invalidDiscount.push(' Discount');
          }
        }

        return isvalid;
      });
      const updatedTableNonItemRow = [...nonItems];
      updatedTableNonItemRow.map((ele, ind) => {
        if (ele?.ledgerAccount?.value !== '') {
          if (ele?.ledgerAccount?.value === '') {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('ledgerAccount' + ind);
            requireds.push('Ledger Account');
          }
          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                nonItemValid = false;
                errorArr.push('nonGSTRate' + ind);
                requireds.push('GST Rate');
              }
            }
          }
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            companyType === 2
            // partyType === 'CUSTOMER'
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('nonhsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }

          if (ele?.taxableAMount === '' || Number(ele?.taxableAMount) === 0 || ele?.taxableAMount === '0') {
            isvalid = false;
            nonItemValid = false;
            if (registrationType != 1) {
              requireds.push('Taxable Amount');
              errorArr.push('nontaxableAMount' + ind);
            } else {
              requireds.push('Net Amount');
              errorArr.push('nontaxableAMount' + ind);
            }
          }
        }

        return isvalid;
      });
      if (isvalid) {
        if (totNetAmt === 0) {
          if (updatedTableItemRow.length === 0 && updatedTableNonItemRow.length === 0) {
            setItems([newItemObj]);
            setNonItems([newNonItemObj]);
          }
          isvalid = false;
          setBackdropOpen(false);
          showWarningSnackbar('Please complete the actions in your entry table');
        }
      }
      if (isvalid) {
        isvalid = checkPriceTypeWithInvDate(data?.invoiceDate);
      }
      if (isvalid) {
        if (!checkEwayBillAddress()) {
          setBackdropOpen(false);
          isvalid = false;
        }
      }
      if (isvalid) {
        try {
          const comments = data.remarks;
          let invMasterArr = [];
          let invDispatchArr = [];
          let invLineItemArr = [];
          let invNonLineItemArr = [];
          let tcsArr = [];
          let invAddArr = [];
          let invTransactionArray = [];
          let invLineGstArr = [];
          let invLineNonGstArr = [];
          let randomNum = Math.floor(Math.random() * 100 + 1);
          let timeStamp = Math.floor(new Date().getTime() / 1000);
          let randomNumber = randomNum + timeStamp.toString().slice(3, 10);

          const invMasterData = {
            invoicepdf: String(uri),
            adjustmentamount: Number(adjustments),
            comments: String(comments),
            reversechargeflag: Number(data.reverseChargeFlag),
            balancedueamount: Number(data.balanceDueAmt),
            creditduration: isNaN(Number(creditPeriod)) ? 0 : Number(creditPeriod),
            customerordernumber: String(orderNumber),
            customerorderdate: customerOrderDate ? Math.floor(new Date(customerOrderDate).getTime() / 1000) : 0,
            exchangerate: Number(receivedAmount),
            invoiceamount: Number(netAmountToPay),
            invoicebillingaddressid: 10,
            invoicecurrencycd: String(''),
            invoicedate: Math.floor(new Date(invoiceDate).getTime() / 1000),
            invoicedeliveryaddressid: 10,
            invoicelinetypecd: String(''),
            invoicenumber: String(data.voucherNumber === '' ? 0 : data.voucherNumber),
            invoicetaxabletypecd: String(taxability?.value),
            invoicetypecd: String('SalesInvoice'),
            partyid: Number(partyName.value),
            paymentaccountid: String(receivedAccount.value) === '' ? 0 : Number(receivedAccount.value),
            placeofsupply: String(placeOfSupply.value),
            paymenttype: String(paymentType),
            receipturl: String(''),
            receivedamount: Number(receivedAmount),
            bankreferencenumber: paymentType === 'Bank' ? String(data?.bankReferenceNo) : String(''),
            entrydate: Math.floor(Date.now() / 1000),
            transactiontypecd: String('SalesInvoice'),
            tcsapplicableflag: Number(data.tcsFlag),
            serialnumber: Number(voucherFlag===-1)?"":String(data.seriesVouchers.value),
            consigneename: data.consigneeName !== '' ? String(data.consigneeName) : String(''),
            consigneegstin: data.consigneeGST !== '' ? String(data.consigneeGST) : String(''),
            companystate: String(companyState),
            roundoffamount: Number(data.roundOff),
            discounttype: Number(data.adjustmentsType),
            discountvalue: Number(data.adjustmentsValue),
            currencycode: String(data.currency.value),
            currencyrate: Number(data.currencyRate),
            bankaccountid: 0,
            bankamount: 0,
            serialflag:Number(generalSettingsFlag)===-1?0:Number(data?.seriesVouchers?.serialflag),
            taxability:Number(data?.taxType),
            cessexist:Number(isCessFlag)
            // partydisplayname: String(data?.partyName?.label),
          };

          invMasterArr.push(invMasterData);
          const dispatchData = {
            dispatchdate: data.dateOfDispatch ? Math.floor(new Date(data.dateOfDispatch).getTime() / 1000) : 0,
            dispatchid: Number(randomNumber),
            ewaybillnumber: String(data.ewayBillNo) || '',
            transportationcd: String(data.transportMode),
            vehiclenumber: String(data.vehicleNumber),
          };

          invDispatchArr.push(dispatchData);

          if (items.length > 0) {
            items.map((ele, index) => {
              if (ele?.itemCode?.value !== '') {
                const lineItem = {
                  invoiceitemid: Number(index + 1),
                  lineitemnumber: Number(index + 1),
                  invoicelineitemtype: String('ITEM'),
                  itemid: Number(ele.name.value),
                  quantity: Number(ele.qty),
                  unittypecd: String(ele.units),
                  itemrate: Number(ele.rate),
                  itemamount: Number(ele.amount),
                  itemdiscount: Number(ele.dicount),
                  netamount: Number(ele.netAmount),
                  hsnsaccode: String(ele.HSN.value === '' ? 0 : ele.HSN.value),
                  taxability: String(data?.taxability.value),
                  pricetype: String(ele?.priceType?.label),
                  manualdiscount: ele?.manualDiscount === true ? 1 : 0,
                  manualcess: Number(ele?.manualCess),
                  pricetypeid: Number(ele?.priceType?.value),
                  itemtype: String(ele.itemType),
                  manualgst: Number(ele?.manualGSTFlag),
                    discounttype:String(ele?.discountType),
            discountrate:Number(ele.discountRate),
                };

                invLineItemArr.push(lineItem);
                const gstData = {
                  invoiceitemid: Number(index + 1),
                  gstrate: Number(ele.GSTRate),
                  gsttypecd: String(''),
                  gstamount: Number(ele.IGST),
                  cessamount: Number(ele.GSTCess),
                  cesstype:String(ele?.cessType),
                  cessrate:Number(ele?.cessRate)
                };

                invLineGstArr.push(gstData);
              }
            });
          }
          if (nonItems.length > 0) {
            nonItems.map((ele, index) => {
              if (ele?.ledgerAccount?.value !== '') {
                const lineNonItem = {
                  invoiceitemid: Number(index + 1),
                  invoicelineitemtype: String('NONITEM'),
                  incomeaccountid: Number(ele.ledgerAccount.value),
                  hsnsaccode: String(ele.HSN.value === '' ? 0 : ele.HSN.value),
                  taxability: String(data?.taxability.value),
                  itemdescription: String(ele.description),
                  taxableamount: Number(ele.taxableAMount),
                  netamount: Number(ele.netAmount),
                  manualgst: Number(ele?.manualGSTFlag),
                  manualcess:Number(ele?.manualCess)
                  
                };

                invNonLineItemArr.push(lineNonItem);
                const gstData = {
                  invoiceitemid: Number(index + 1),
                  gstrate: Number(ele.GSTRate),
                  gsttypecd: String(''),
                  gstamount: Number(ele.IGST),
                  cessamount: Number(ele.GSTCess),
                  cesstype:String(ele?.cessType),
                  cessrate:Number(ele?.cessRate)
                };

                invLineNonGstArr.push(gstData);
              }
            });
          }
          const tcsData = {
            tcsapplicablecd: String(data.tcsFlag === '' ? 0 : data.tcsFlag),
            totaltaxableamount: Number(totTaxAmt),
            ineligibletcflag: Number(data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag),
            reversechargeflag: Number(data.reverseChargeFlag),
            gstcesstotal: Number(totGSTCess),
            tcsamount: Number(data.tcsAmount),
            adjustmentamount: Number(data.adjustments),
            tcssection: String(data.tcsOptions),
            tcspercentage: Number(data.tcsPercent),
            tcsmanual: Number(data.manualTcsFlag),
          };

          tcsArr.push(tcsData);
          if (isAdrressEmpty) {
            let add = deliveryAddressDetails.deliveryAddress !== '' ? deliveryAddressDetails.deliveryAddress :"";
            const addressDetails = {
              consigneename: data.consigneeName !== '' ? String(data.consigneeName) : String(''),
              consigneegstin: data.consigneeGST !== '' ? String(data.consigneeGST) : String(''),
              objecttype: String('SalesDelivery'),
              // line1: String(add?.join('**')),
              line1: String(add),
              line2: String(''),
              line3: String(''),
              city: String(deliveryAddressDetails.city?.value ?? ''),
              statecode: Number(deliveryAddressDetails.states ?? 0),
              pincode: String(deliveryAddressDetails.pincode ?? ''),
              countrycode: String(deliveryAddressDetails.country ?? ''),
              district: String(deliveryAddressDetails.district ?? ''),
              foreignstate:String(deliveryAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(deliveryAddressDetails.districtCD?.label ?? '')
            };
            invAddArr.push(addressDetails);
          }
          let billAdd = billingAddressDetails.billingAddress !== '' ? billingAddressDetails.billingAddress : "";
          if(!isBillAddressEmpty){
          const billaddressDetails = {
            consigneename: data.partyName?.label !== '' ? String(data.partyName?.label) : String(''),
            consigneegstin: data.gstin !== '' ? String(data.gstin) : String(''),
            objecttype: String('SalesBilling'),
            // line1: String(billAdd?.join('**')),
            line1: String(billAdd),
            line2: String(''),
            line3: String(''),
            city: String(billingAddressDetails.city?.value ?? ''),
            statecode: Number(billingAddressDetails.states ?? 0),
            pincode: String(billingAddressDetails.pincode ?? ''),
            countrycode: String(billingAddressDetails.country ?? ''),
            district: String(billingAddressDetails.district ?? ''),
            foreignstate:String(billingAddressDetails?.stateCD?.label??''),
            foreigndistrict:String(billingAddressDetails.districtCD?.label ?? '')
          };

          invAddArr.push(billaddressDetails);
        }

          invTransArr.map((ele, ind) => {
            let obj = {
              transactiontypecd: String(ele.debitAmt !== 0 ? 'Debit' : 'Credit'),
              accountid: Number(ele.accID),
              creditamount: Number(Number(ele.creditAmt).toFixed(2)),
              debitamount: Number(Number(ele.debitAmt).toFixed(2)),
              comments: String(data.remarks),
              // entryordernumber: Number(ind + 1),
              // cancelflag: Number(0),
            };

            invTransactionArray.push(obj);
          });

          // const attachedArr = itemsRows.map((ele) => ({
          //   documentname: ele.documentname,
          //   attachmentname: ele.imagename,
          //   attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`,
          //   type: ele?.type?.split("/")[1],
          // }));
          const attachedArr = itemsRows.map((ele) => ({
            type: String(ele?.type?.split('/')[1]),
            documentname: String(ele.documentname),
            attachmenturl: String(`${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename}`),
          }));

          const resSalesInvoice = await API.graphql(
            graphqlOperation(createSalesPosInvoiceTemp, {
              createSalesInvoiceInput: {
                posphonecontacts: [],
                posparty: [],
                denominations: [], // if needed, populate this array
                invoicedispatch: invDispatchArr,
                invoicelinegst: invLineGstArr,
                invoicelinenongst: invLineNonGstArr,
                invoicelineitems: invLineItemArr,
                invoicelinenonitems: invNonLineItemArr,
                invoicetcsdetails: tcsArr,
                invoicetransactionmaster: invMasterArr,
                partyaddressentity: invAddArr,
                transactiondetails: invTransactionArray,
                invoiceattachment: attachedArr,
              },
            })
          );

          if (resSalesInvoice.data.createSalesPosInvoiceTemp.statuscode !== null) {
            let responses = itemsRows.map((element) => {
              if (element.file) {
                return uploadToServer(
                  element.file,
                  element.imagename.replace('${id}', resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid),
                  element.type
                );
              }
            });
            dispatch(dashboardApi.util.invalidateTags(['dashboard', 'Dashboard_closingStock',"bizview"]));

            dispatch(setNavigationBlocked(false));
            await savePaymentDetails(resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid);

            setInvID(resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid);

            const selectedParty = partyNameOptions.find((obj) => obj.accountsID === partyAccountID);
            setSelected([
              {
                PartyDisplayName: selectedParty?.label,
                Email: selectedParty?.email,
                PartyID: selectedParty?.value,
                invoiceid: resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid,
                voucherNumber: data.voucherNumber,
              },
            ]);

            showSuccessSnackbar('Invoice generated successfully');
            createPdf({
              path: url,
              type: 'salesInvoice',
              invoiceids: resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid,
            });
            const partyBilling =
              partyBillAddressEntity.district !== '' &&
              partyBillAddressEntity.line1 !== '' &&
              partyBillAddressEntity.pincode !== '' &&
              partyBillAddressEntity.statecode !== '';
            const partyDelivery =
              partyDeliveryAddressEntity.district !== '' &&
              partyDeliveryAddressEntity.line1 !== '' &&
              partyDeliveryAddressEntity.pincode !== '' &&
              partyDeliveryAddressEntity.statecode !== '';
            if (obj.new == false) {
              if (isSalesShow === 1) {
                setShareOpen(url);
              }

              if (eImp === false && eWayImp === false) {
                setBackdropOpen(false);
                if (isSalesShow === 0) {
                  navigate('/salesInvoiceReport');
                }
              } else {
                if (eImp === true) {
                  if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect === 0) {
                    setConnectCheckbox('invoice');
                    let result;
                    do {
                      result = await showEInvAuthModal('invoice');
                    } while (result !== 'success');
                    showSuccessSnackbar('Validated successfully');
                    await modalRef.current.triggerCustomAction(resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, false);
                  } else {
                    showSuccessSnackbar('Invoice generated. Please wait for e-invoice...');
                    await modalRef.current.triggerCustomAction(resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, false);
                  }
                }
                if (eWayImp === true) {
                  if (partyBilling === false && partyDelivery === false) {
                    showWarningSnackbar('Please add/complete billing and delivery address for party to create e way bill');
                    navigate('/salesInvoiceReport');
                  } else if (partyBilling === false && partyDelivery === true) {
                    showWarningSnackbar('Please add/complete billing address for party to create e way bill');
                    navigate('/salesInvoiceReport');
                  } else if (partyBilling === true && partyDelivery === false) {
                    showWarningSnackbar('Please add/complete delivery address for party to create e way bill');
                    navigate('/salesInvoiceReport');
                  }
                  if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect === 0) {
                    setConnectCheckbox('eway');
                    let result;
                    do {
                      result = await showEInvAuthModal('eway');
                    } while (result !== 'success');
                    showSuccessSnackbar('Validated successfully');
                    ewayNav(data, resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, Number(partyName.value), false);
                  } else {
                    setBackdropOpen(true);
                    setTimeout(() => {
                      ewayNav(data, resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, Number(partyName.value), false);
                    }, 1000);
                  }
                }

                setBackdropOpen(false);
                // if (eImp === true) {
                //   if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect === 0) {
                //     setConnectCheckbox('invoice');
                //     setAuthInv(true);
                //     setPreviewSalesTaxableModal(false);
                //   } else {
                //     showSuccessSnackbar('Invoice generated Please wait for e invoice to be generated ...');
                //     if (modalRef.current) {
                //       setBackdropOpen(true);
                //       modalRef.current.triggerCustomAction(resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid);
                //       setBackdropOpen(false);
                //     }
                //   }
                // }
                // if (eWayImp === true) {
                //   if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 1) {
                //     ewayNav(data, resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, Number(partyName.value));
                //   } else {
                //     setConnectCheckbox('eway');
                //     setAuthInv(true);
                //   }
                // }

                // setBackdropOpen(false);
              }
            } else {
              setSaveNew(true);
              // if (eWayImp === true && eImp === true) {
              //   setEwayOpen(true);
              // } else
              if (eImp === false && eWayImp === false) {
                setBackdropOpen(false);
                if (isSalesShow === 0) {
                  navigate('/salesInvoiceReport');
                }
              } else {
                if (eImp === true) {
                  if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect === 0) {
                    setConnectCheckbox('invoice');
                    let result;
                    do {
                      result = await showEInvAuthModal('invoice');
                    } while (result !== 'success');
                    showSuccessSnackbar('Validated successfully');
                    await modalRef.current.triggerCustomAction(resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, true);
                  } else {
                    showSuccessSnackbar('Invoice generated. Please wait for e-invoice...');
                    await modalRef.current.triggerCustomAction(resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, true);
                  }
                }
                if (eWayImp === true) {
                  if (partyBilling === false && partyDelivery === false) {
                    showWarningSnackbar('Please add billing and delivery address for party to create e way bill');
                    navigate('/salesInvoiceReport');
                  } else if (partyBilling === false && partyDelivery === true) {
                    showWarningSnackbar('Please add billing address for party to create e way bill');
                    navigate('/salesInvoiceReport');
                  } else if (partyBilling === true && partyDelivery === false) {
                    showWarningSnackbar('Please add delivery address for party to create e way bill');
                    navigate('/salesInvoiceReport');
                  }
                  if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect === 0) {
                    setConnectCheckbox('eway');
                    let result;
                    do {
                      result = await showEInvAuthModal('eway');
                    } while (result !== 'success');
                    showSuccessSnackbar('Validated successfully');
                    ewayNav(data, resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, Number(partyName.value), true);
                  } else {
                    setTimeout(() => {
                      ewayNav(data, resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, Number(partyName.value), true);
                    }, 1000);
                  }
                }

                setBackdropOpen(false);
                // if (eImp === true) {
                //   if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect === 0) {
                //     setConnectCheckbox('invoice');
                //     setAuthInv(true);
                //     setPreviewSalesTaxableModal(false);
                //   } else {
                //     showSuccessSnackbar('Invoice generated Please wait for e invoice to be generated ...');
                //     if (modalRef.current) {
                //       setBackdropOpen(true);
                //       modalRef.current.triggerCustomAction(resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid);
                //       setBackdropOpen(false);
                //     }
                //   }
                // }
                // if (eWayImp === true) {
                //   if (getCompany.relatedcompanydetailsnew[0].ewaybillconnect == 1) {
                //     ewayNav(data, resSalesInvoice.data.createSalesPosInvoiceTemp.invoiceid, Number(partyName.value));
                //   } else {
                //     setConnectCheckbox('eway');
                //     setAuthInv(true);
                //   }
                // }

                // setBackdropOpen(false);
              }

              setBackdropOpen(false);
              setData((prev) => ({
                ...resetData,
                invoiceDate: prev?.invoiceDate,
                customerOrderDate: prev?.customerOrderDate,
              }));

              // getVoucherDetails("Receipt");
              getLastSalesInvoice();
              dispatch(VoucherSettingsApi.util.invalidateTags([{ type: 'listVoucherSettings', id: 'SalesInvoice' }]));
              dispatch(VoucherSettingsApi.util.invalidateTags(['listUsedVoucherSettings']));
              setNonItems([resetNonItems]);
              setItems([resetItems]);
              setItemValid(true);
              setNonItemValid(true);
              setItemsRows([]);
              setSaveNew(false);
            }
          } else {
            setBackdropOpen(false);

            showErrorSnackbar(resSalesInvoice.data.createSalesPosInvoiceTemp.statusmessage);
          }
        } catch (error) {
          const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
          const parsedMessage = JSON.parse(rawMessage).message;
          const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
          showWarningSnackbar(errorMessage);
          console.log('error', error);
          setBackdropOpen(false);
        }
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        requireds = [...new Set(requireds)];
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'are required');
        }
        setItemValid(itemValid);
        setNonItemValid(nonItemValid);
      }
    } else {
      setErrorArr({ ...data.errorStatus });
    }
  }
  async function saveEditChanges() {
    const {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    } = data;

    const formData = {
      invoiceDate,
      orderNumber,
      customerOrderDate,
      paymentType,
      receivedAmount,
      receivedAccount,
      creditPeriod,
      bankReferenceNo,
      dueDate,
      adjustments,
      transportMode,
      vehicleNumber,
      dateOfDispatch,
      ewayBillNo,
      remarks,
      placeOfSupply,
      partyName,
      voucherNumber,
      transactionVoucher,
      currencyRate,
      taxability,
    };
    if (formVaidation(formData)) {
      setBackdropOpen(true);
      const updatedTableItemRow = [...items];
      let isvalid = true;
      let requireds = [];
      let invalids = [];
      let invalidDiscount = [];
      let errorArr = [];
      let itemValid = true;
      let nonItemValid = true;
     const voucherNo =
        data?.voucherNumber?.trim()
          ? data.voucherNumber
          : String(data?.seriesVouchers?.label || '');
 
      const InvUrl = `${path}Invoices/Sales/Ledgerx_Sales_Invoice_${voucherNo}.pdf`;
       
        let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${InvUrl}`;

      updatedTableItemRow.map((ele, ind) => {
        if (ele?.itemCode?.value !== '') {
          if (ele?.itemCode?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemCode' + ind);
            requireds.push('Item Code');
          }
          if (ele?.name?.value === '') {
            isvalid = false;
            itemValid = false;
            errorArr.push('itemName' + ind);
            requireds.push('Item Name');
          }

          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                itemValid = false;
                errorArr.push('GSTRate' + ind);
                requireds.push('GST Rate');
              }
            }
          }
          if (
            (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
            // EInvoiceFlag &&
            companyType === 2
            // partyType === 'CUSTOMER'
            // &&
            // data.partyCategory !== "UB"
          ) {
            isvalid = false;
            itemValid = false;
            errorArr.push('hsnCode' + ind);
            requireds.push('HSN/SAC Code');
          }
          if (ele?.qty !== '' && !new RegExp(/^(?=.+)(?:[1-9]\d*|0\d*)?(?:\.\d+)?$/).test(ele?.qty)) {
            isvalid = false;
            itemValid = false;
            invalids.push(' Quantity');
          }
          if (ele?.qty !== 0 && (ele?.rate == '' || ele?.rate == 0)) {
            isvalid = false;
            itemValid = false;
            requireds.push('Rate');
            errorArr.push('rate' + ind);
          }
          if (ele?.dicount !== '' && Number(ele?.dicount) > Number(ele?.amount)) {
            isvalid = false;
            itemValid = false;
            errorArr.push('dicount' + ind);
            invalidDiscount.push(' Discount');
          }
        }

        return isvalid;
      });
      const updatedTableNonItemRow = [...nonItems];
      updatedTableNonItemRow.map((ele, ind) => {
        if (ele?.ledgerAccount?.value !== '') {
          if (ele?.ledgerAccount?.value === '') {
            isvalid = false;
            nonItemValid = false;
            errorArr.push('ledgerAccount' + ind);
            requireds.push('Ledger Account');
          }
          if (registrationType != 1) {
            if (
              data?.taxability?.value == 1 ||
              data?.taxability?.value == 4 ||
              data?.taxability?.value == 6 ||
              data?.taxability?.value == 8 ||
              data?.taxability?.value == 9 ||
              data?.taxability?.value == 7 ||
              data?.taxability?.value === ''
            ) {
              if (ele?.GSTRate === '') {
                isvalid = false;
                nonItemValid = false;
                errorArr.push('nonGSTRate' + ind);
                requireds.push('GST Rate');
              }
            }
            if (
              (ele?.HSN?.value === '' || ele?.HSN?.value === undefined || ele?.HSN?.value === null) &&
              // EInvoiceFlag &&
              // partyType === 'CUSTOMER'
              companyType === 2 &&
              partyType === 'CUSTOMER'
              //  &&
              // data.partyCategory !== "UB"
            ) {
              isvalid = false;
              nonItemValid = false;
              errorArr.push('nonhsnCode' + ind);
              requireds.push('HSN/SAC Code');
            }
          }
          if (ele?.taxableAMount === '' || Number(ele?.taxableAMount) === 0 || ele?.taxableAMount === '0') {
            isvalid = false;
            nonItemValid = false;
            if (registrationType != 1) {
              requireds.push('Taxable Amount');
              errorArr.push('nontaxableAMount' + ind);
            } else {
              requireds.push('Net Amount');
              errorArr.push('nontaxableAMount' + ind);
            }
          }
        }

        return isvalid;
      });
      if (isvalid) {
        if (totNetAmt === 0) {
          if (updatedTableItemRow.length === 0 && updatedTableNonItemRow.length === 0) {
            setItems([newItemObj]);
            setNonItems([newNonItemObj]);
          }
          isvalid = false;
          setBackdropOpen(false);
          showWarningSnackbar('Please complete the actions in your entry table');
        }
      }

      if (isvalid) {
        const comments = data.remarks;

        const masterData = {
          invoicepdf:String(uri),
          //  invoiceEntry?.invoicepdf,
          adjustmentamount: Number(adjustments),
          comments: comments,
          expiredtimestamp: 0,
          reversechargeflag: data.reverseChargeFlag,
          balancedueamount: Number(data.balanceDueAmt),
          creditduration: isNaN(Number(creditPeriod)) ? 0 : Number(creditPeriod),
          customerordernumber: orderNumber,
          customerorderdate: customerOrderDate ? Math.floor(new Date(customerOrderDate).getTime() / 1000) : 0,
          exchangerate: Number(receivedAmount),
          invoiceamount: netAmountToPay,
          invoicebillingaddressid: 10,
          invoicetaxabletypecd: String(taxability?.value),
          invoicecurrencycd: '',
          invoicedate: Math.floor(new Date(invoiceDate).getTime() / 1000),
          invoicedeliveryaddressid: 10,
          invoiceid: invoiceEntry.invoiceid,
          invoicenumber: data.voucherNumber===""?String(data.seriesVouchers.label):String(data.voucherNumber),
          serialnumber: Number(voucherFlag===-1)?"":String(data.seriesVouchers.value),
          invoicetypecd: 'SalesInvoice',
          partyid: partyName.value,
          paymentaccountid: receivedAccount.value == '' ? 0 : receivedAccount.value,
          placeofsupply: String(placeOfSupply.value),

          paymenttype: paymentType,
          receipturl: '',
          receivedamount: data?.paymentDeletionFlag === true ? 0 : Number(receivedAmount),
          tcsapplicableflag: data.tcsFlag,
          consigneename: data.consigneeName !== '' ? data.consigneeName : '',
          consigneegstin:
            data.consigneeGST !== '' && data.consigneeGST !== undefined && data.consigneeGST !== null ? data.consigneeGST : '',
          companystate: String(companyState),
          roundoffamount: Number(data.roundOff),
          discounttype: Number(data.adjustmentsType),
          discountvalue: Number(data.adjustmentsValue),
          currencycode: String(data.currency.value),
          currencyrate: Number(data.currencyRate),
          cancelremark: '',
          deleteremark: '',
          financialyearid: userPreferece?.financialYear?.financialyearid,
          cancelflag: 0,
          invoicelinetyped: '',
          paymentstatus: 0,
          bankaccountid: 0,
          bankamount: 0,
          partydisplayname: data?.partyName?.label,
          serialflag:Number(generalSettingsFlag)===-1?0:Number(data?.seriesVouchers?.serialflag),
          taxability:Number(data?.taxType),
          cessexist:Number(isCessFlag)
        };
        updateInvoiceMasterData(masterData);
      } else {
        setBackdropOpen(false);
        setTableErrArr(errorArr);
        requireds = [...new Set(requireds)];
        if (requireds.length === 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'is required');
        }
        if (requireds.length > 1) {
          showWarningSnackbar(`${requireds}` + ' ' + 'are required');
        }
        setItemValid(itemValid);
        setNonItemValid(nonItemValid);
      }
    }
  }

  async function updateInvoiceMasterData(masterData) {
    try {
      let variables = {};
      let invLineItemArr = [];
      let invLineGstArr = [];
      let invNonLineItemArr = [];
      let invoiceLineNonGstArr = [];
      let addressArr = [];
      let invTransactionArray = [];
      
let currentMaxInvoiceItemId = Math.max(
  0,
  ...[...items, ...deletedItems]
    .map((ele) => Number(ele?.invoiceitemid || 0))
    .filter((id) => !isNaN(id))
);
      
      [...items, ...deletedItems].map(async (ele, index) => {
        if (ele?.itemCode?.value !== '') {
            if (!ele?.invoiceitemid) {
      currentMaxInvoiceItemId += 1;
      ele.invoiceitemid = currentMaxInvoiceItemId;
    }
          const lineItem = {
            hsnsaccode: String(ele?.HSN?.value === '' ? 0 : ele?.HSN?.value),
            invoicelineitemtype: 'ITEM',
            itemamount: Number(ele.amount),
            itemdiscount: Number(ele.dicount),
            itemid: Number(ele?.name?.value),
            itemname: ele?.name?.label,
            itemrate: Number(ele.rate),
            taxability: data?.taxability?.value,
            lineitemnumber: index + 1,
            netamount: Number(ele.netAmount),
            quantity: Number(ele.qty),
            pricetype: ele?.priceType?.label,
            pricetypeid: ele?.priceType?.value,
            unittypecd: ele.units,
            invoiceid: invoiceEntry?.invoiceid,
            invoiceitemid: ele?.invoiceitemid ? ele?.invoiceitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            lotid: 0,
            companybranchid: 0,
            manualdiscount: ele?.manualDiscount === true ? 1 : 0,
            manualcess: ele?.manualCess === true ? 1 : 0,
            itemtype: String(ele.itemType),
            invoicedate: Math.floor(new Date(data?.invoiceDate).getTime() / 1000),
            manualgst: Number(ele?.manualGSTFlag),
             discounttype:String(ele?.discountType),
            discountrate:Number(ele.discountRate),
          
          };
          invLineItemArr.push(lineItem);

          const gstData = {
            cessamount: Number(ele.GSTCess),
            gstamount: Number(ele.IGST),
            gstrate: Number(ele.GSTRate),
            gsttypecd: '',
            invoiceid: invoiceEntry?.invoiceid,
            invoiceitemid: ele?.invoiceitemid ? ele?.invoiceitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
              cesstype:String(ele?.cessType),
              cessrate:Number(ele.cessRate)
          };
          invLineGstArr.push(gstData);
        }
      });
      let currentMaxInvoiceNonItemId = Math.max(
  0,
  ...[...nonItems, ...deletedNonItems]
    .map((ele) => Number(ele?.invoiceitemid || 0))
    .filter((id) => !isNaN(id))
);
      [...nonItems, ...deletedNonItems].map(async (ele, index) => {
        if (ele?.ledgerAccount?.value !== '') {
            if (!ele?.invoiceitemid) {
      currentMaxInvoiceNonItemId += 1;
      ele.invoiceitemid = currentMaxInvoiceNonItemId;
    }
          const lineNonItem = {
            hsnsaccode: String(ele.HSN.value === '' ? 0 : ele.HSN.value),
            incomeaccountid: ele?.ledgerAccount?.value,
            invoicelineitemtype: 'NONITEM',
            itemdescription: ele.description,
            taxability: data?.taxability?.value,
            netamount: Number(ele.netAmount),
            taxableamount: Number(ele.taxableAMount),
            invoiceid: invoiceEntry?.invoiceid,
            invoiceitemid: ele?.invoiceitemid ? ele?.invoiceitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
            manualgst: Number(ele?.manualGSTFlag),
            manualcess:Number(ele.manualCess)
          };
          invNonLineItemArr.push(lineNonItem);

          const gstData = {
            cessamount: Number(ele.GSTCess),
            gstamount: Number(ele.IGST),
            gstrate: Number(ele.GSTRate),
            gsttypecd: '',
            invoiceid: invoiceEntry?.invoiceid,
            invoiceitemid: ele?.invoiceitemid ? ele?.invoiceitemid : index + 1,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
            cesstype:String(ele?.cessType),
              cessrate:Number(ele.cessRate)
          };
          invoiceLineNonGstArr.push(gstData);
        }
      });

      const dispatchData = {
        dispatchdate: data.dateOfDispatch == '' ? 0 : Math.floor(new Date(data.dateOfDispatch).getTime() / 1000),

        expiredtimestamp: 0,
        dispatchid: invoiceEntry?.relatedinvoicedispatch[0]?.dispatchid,
        ewaybillnumber: data.ewayBillNo,
        invoiceid: invoiceEntry?.invoiceid,
        transportationcd: data.transportMode,
        vehiclenumber: data.vehicleNumber,
        companybranchid: 0,
      };
      if (isAdrressEmpty) {
        let add = deliveryAddressDetails?.deliveryAddress !== '' ? deliveryAddressDetails?.deliveryAddress:"";
        const addressDetails = {
          consigneename: data.consigneeName !== '' ? String(data.consigneeName) : String(''),
          consigneegstin: data.consigneeGST !== '' ? String(data.consigneeGST) : String(''),
          city: deliveryAddressDetails.city?.value ?? '',

          countrycode: deliveryAddressDetails.country ?? '',

          // line1: add?.join('**'),
          line1: add,
          line2: '',
          line3: '',
          objectid: invoiceEntry?.invoiceid,
          objecttype: 'SalesDelivery',

          pincode: deliveryAddressDetails.pincode ?? '',

          statecode: deliveryAddressDetails?.states ?? 0,

          district: deliveryAddressDetails.district ?? '',

          expiredtimestamp: 0,
          financialyearid: userPreferece?.financialYear?.financialyearid,
          foreignstate:String(deliveryAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(deliveryAddressDetails.districtCD?.label ?? '')
        };
        addressArr.push(addressDetails);
      }else{
        
             const addressDetails = {
              consigneename:String(''),
              consigneegstin:String(''),
              objecttype: String('SalesDelivery'),
              // line1: String(add?.join('**')),
              objectid: invoiceEntry?.invoiceid,
              line1: String(''),
              line2: String(''),
              line3: String(''),
              city: String(''),
              statecode: 0,
              pincode: String(''),
              countrycode: String(''),
              district: String(''),
              foreignstate:String(''),
              foreigndistrict:String(''),
              expiredtimestamp: 0,
          financialyearid: userPreferece?.financialYear?.financialyearid,
            };
            addressArr.push(addressDetails);
          
      }


      let billAdd = billingAddressDetails?.billingAddress !== '' ? billingAddressDetails?.billingAddress : "";
     if(!isBillAddressEmpty){
      const billaddressDetails = {
        consigneename: data?.partyName?.label !== '' ? String(data?.partyName?.label) : String(''),
        consigneegstin: data.gstin !== '' ? String(data?.gstin) : String(''),
        city: billingAddressDetails.city.value ?? '',

        countrycode: billingAddressDetails.country ?? '',

        // line1: billAdd?.join('**'),
        line1: billAdd,
        line2: '',
        line3: '',
        objectid: invoiceEntry?.invoiceid,
        objecttype: 'SalesBilling',

        pincode: billingAddressDetails.pincode ?? '',

        statecode: billingAddressDetails.states ?? 0,

        district: billingAddressDetails.district ?? '',

        expiredtimestamp: 0,
        financialyearid: userPreferece?.financialYear?.financialyearid,
        foreignstate:String(billingAddressDetails?.stateCD?.label??''),
              foreigndistrict:String(billingAddressDetails.districtCD?.label ?? '')
      };
      addressArr.push(billaddressDetails);
    }else{
      const billaddressDetails = {
        consigneename: data?.partyName?.label !== '' ? String(data?.partyName?.label) : String(''),
        consigneegstin: data.gstin !== '' ? String(data?.gstin) : String(''),
        city:  '',
        countrycode:  '',
        line1: '',
        line2: '',
        line3: '',
        objectid: invoiceEntry?.invoiceid,
        objecttype: 'SalesBilling',

        pincode: '',

        statecode: 0,

        district:  '',

        expiredtimestamp: 0,
        financialyearid: userPreferece?.financialYear?.financialyearid,
        foreignstate: String(''),
        foreigndistrict: String('')
    };
    addressArr.push(billaddressDetails);
  }
      Math.floor(new Date().getTime() / 1000);
      const exp = Math.floor(new Date().getTime() / 1000);
      const idsInArray2 = new Set(itemsRows.map((item) => item.attachmentid));

      let arratt = [];
      const updatedArray1 = currentDouments.map((item) => {
        let arr;
        if (!idsInArray2.has(item.attachmentid) && typeof item.attachmentid !== 'string') {
          arr = { ...item, expiredtimestamp: exp };
          arratt.push(arr);
        } else {
          arr = itemsRows.find((att) => att.attachmentid === item.attachmentid);
          arratt.push(arr);
        }
      });

      const additionalItems = itemsRows.filter((item2) => !currentDouments.some((item1) => item1.attachmentid == item2.attachmentid));

      const finalArray = [...arratt, ...additionalItems];
      const attachedArr = finalArray.map((ele) => ({
        attachmentid: typeof ele.attachmentid === 'string' ? 0 : ele.attachmentid,
        invoiceid: invoiceEntry?.invoiceid,
        documentname: ele.documentname,
        attachmentname: ele.imagename,
        attachmenturl: `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${ele.imagename?.replace('${id}', invoiceEntry?.invoiceid)}`,
        type: ele?.type,
        companybranchid: 0,
        expiredtimestamp: ele.expiredtimestamp ? ele.expiredtimestamp : 0,
      }));
      invTransArr.map((ele, ind) => {
        let obj = {
          accountid: Number(ele.accID),
          comments: data.remarks,
          debitamount: Number(ele.debitAmt).toFixed(2),
          creditamount: Number(ele.creditAmt).toFixed(2),
          // entryordernumber: Number(ind + 1),
          transactionid: Number(invoiceEntry?.relatedinvoicetransactiondetails[0]?.transactionid),
          transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
          enteredtimestamp: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
          cancelflag: 0,
        };
        invTransactionArray.push(obj);
      });

      if (attachedArr?.length > 0) {
        let responses = itemsRows.map((element) => {
          if (element.file) {
            return uploadToServer(element.file, element.imagename.replace('${id}', invoiceEntry?.invoiceid), element.type);
          }
        });
      }
      await Promise.all(attachedArr);
      const tcsData = {
        adjustmentamount: Number(data.adjustments),

        expiredtimestamp: 0,
        gstcesstotal: Number(totGSTCess),
        ineligibletcflag: data.ineligibleITCFlag === '' ? 0 : data.ineligibleITCFlag,
        invoiceid: invoiceEntry?.invoiceid,
        reversechargeflag: data.reverseChargeFlag,
        tcsamount: Number(data.tcsAmount),
        tcsapplicablecd: data.tcsFlag === '' ? 0 : data.tcsFlag,
        tcssection: data.tcsOptions,
        totaltaxableamount: Number(totTaxAmt),
        tcspercentage: Number(data.tcsPercent),
        tcsmanual: data.manualTcsFlag,
        companybranchid: 0,
      };
      if (attachedArr.length > 0) {
        variables = {
          createInvoiceMasterInput: masterData,
          createInvoiceLineItemsInput: invLineItemArr,
          createInvoiceLineGSTInput: invLineGstArr,
          createInvoiceLineNonItemsInput: invNonLineItemArr,
          createInvoiceLineNonGSTInput: invoiceLineNonGstArr,
          createInvoiceDispatchInput: dispatchData,
          createPartyAddressEntityInput: addressArr,
          createInvoiceAttachmentInput: attachedArr,
          createInvoiceTCSDetailsInput: [tcsData],
          createTransactionWithSpecificTimeInput: {
            transactionmaster: [],
            transactiondetails: invTransactionArray,
            transactionattachment: [],
            transactiontdsdetails: [],
            transactionrelation: [],
            mode: 0,
            transactiontcsdetails: [],
          },
        };
      } else {
        variables = {
          createInvoiceMasterInput: masterData,
          createInvoiceLineItemsInput: invLineItemArr,
          createInvoiceLineGSTInput: invLineGstArr,
          createInvoiceLineNonItemsInput: invNonLineItemArr,
          createInvoiceLineNonGSTInput: invoiceLineNonGstArr,
          createInvoiceDispatchInput: dispatchData,
          createPartyAddressEntityInput: addressArr,
          createInvoiceTCSDetailsInput: [tcsData],
          createTransactionWithSpecificTimeInput: {
            transactionmaster: [],
            transactiondetails: invTransactionArray,
            transactionattachment: [],
            transactiontdsdetails: [],
            transactionrelation: [],
            mode: 0,
            transactiontcsdetails: [],
          },
        };
      }

      const response = await API.graphql(
        graphqlOperation(attachedArr?.length > 0 ? createInvoiceBatch : createInvoiceBatchWithoutImages, variables)
      );

      await updatePaymentDetails(response?.data?.createInvoiceMaster?.invoiceid);
      if (response.data?.createInvoiceMaster?.statuscode === 'Error') {
        showWarningSnackbar(response?.data?.createInvoiceMaster.statusmessage);
      } else {
        setBackdropOpen(false);
        showSuccessSnackbar('Invoice updated successfully');
        dispatch(setNavigationBlocked(false));
        if (eImp) {
          navigate('/viewnewinvoicetax', {
            state: {
              id: response?.data?.createInvoiceMaster?.invoiceid,
              view: true,
              irn: null,
            },
          });
        } else {
          navigate('/salesInvoiceReport');
        }
        // if (prev.preview === false) {
        //   navigate("/salesInvoiceReport");
        // } else {
        //   setPreviewSalesTaxableModal(true);
        // }

        // if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect == 0) {
        //   dispatch(einvAuth(true));
        //   setPreviewSalesTaxableModal(false);
        //   // dispatch(einvPreview(false));
        // } else {
        //   setEObj(true);
        //   dispatch(einvPreview(true));
        // }

       const voucherNo =
          data?.voucherNumber?.trim()
            ? data.voucherNumber
            : String(data?.seriesVouchers?.label || '');
 
        const InvUrl = `${path}Invoices/Sales/Ledgerx_Sales_Invoice_${voucherNo}.pdf`;
 
        await createPdf({
          path: InvUrl,
          type: 'salesInvoice',
          invoiceids: response.data.createInvoiceMaster.invoiceid,
        });
      }
    } catch (error) {
      console.log('error', error);
      const errorMessage = error.errors?.[0]?.message;
      showErrorSnackbar(errorMessage);
      setBackdropOpen(false);
      // showErrorSnackbar("Something went wrong.Please  try again");
    }
  }
  async function updatePaymentDetails(invID) {
    try {
      let tranSDetailsArr = [];
      let linkedArr = [];
      const comments = data.remarks.split('\n');
      if (data.paymentType !== 'Credit') {
        if (paymentTransID !== '') {
          const transMaster = {
            transactionid: paymentTransID,
            bankreferencenumber: data.bankReferenceNo,
            entrydate: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
            comments: comments?.join('**'),
            vouchernumber: data.transactionVoucher,
            serialnumber: data.transactionSeries.value,
            transactiontypecd: data.paymentType == 'Cash' ? 'CashReceipt' : data.paymentType == 'Bank' ? 'BankReceipt' : 'Credit',
            cancelflag: 0,
          };

          paymentTransArr.map((ele, index) => {
            const paymentTransDetails = {
              accountid: ele.accID,
              comments: comments?.join('**'),
              creditamount: Number(ele.creditAmt),
              debitamount: Number(ele.debitAmt),
              entryordernumber: index + 1,
              transactionid: paymentTransID,
              transactiontypecd: ele.debitAmt !== 0 ? 'Debit' : 'Credit',
              enteredtimestamp: Math.floor(new Date(data.invoiceDate).getTime() / 1000),
              cancelflag: 0,
            };
            tranSDetailsArr.push(paymentTransDetails);
          });

          const linkCurrentPayment = {
            linkedamount: Number(data.receivedAmount),
            transactiontypecd: 'SalesInvoice',
            isdirect: 1,
            objectattribute: data.voucherNumber,
            objectid: invoiceEntry?.invoiceid,
            objecttype: data.paymentType,
            transactionid: paymentTransID,
            accountid: partyAccountID,
            paymentvouchernumber: data?.transactionVoucher,
          };
          linkedArr.push(linkCurrentPayment);
          linkedTransArr.map(async (ele) => {
            let linkTransData = {
              linkedamount: Number(ele.linkedamount),
              transactiontypecd: 'SalesInvoice',
              isdirect: 0,
              objectattribute: data?.voucherNumber,
              objectid: invID,
              objecttype: ele.transactiontypecd,
              transactionid: ele.transactionid,
              accountid: partyAccountID,
              paymentvouchernumber: data?.transactionVoucher,
            };
            linkedArr.push(linkTransData);
          });

          const result = await API.graphql(
            graphqlOperation(createTransactionWithSpecificTime, {
              transactionmaster: JSON.stringify([transMaster]),
              transactiondetails: JSON.stringify(tranSDetailsArr),
              transactionattachment: JSON.stringify([]),
              transactiontdsdetails: JSON.stringify([]),
              transactionrelation: JSON.stringify(linkedArr),
              mode: 0,
              transactiontcsdetails: JSON.stringify([]),
            })
          );
          let url = path + `Invoices/Receipt/Ledgerx_Receipt_${data.transactionVoucher}.pdf`;
          await createPdf({
            path: url,
            type: 'receipt',
            transactionid: result.data?.createTransactionWithSpecificTime?.transactionid,
          });
        } else {
          savePaymentDetails(invID);
        }
      } else {
        if (paymentTransID !== '' && data?.paymentDeletionFlag === true) {
          const deleteTransMaster = await API.graphql(
            graphqlOperation(deleteTransactionMaster, {
              transactionid: paymentTransID,
            })
          );
        }
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  const [errorArr, setErrorArr] = useState({});
  const [shareOpen, setShareOpen] = useState(false);

  useEffect(() => {
    let errorKeys = [];
    if (Object.keys(errorArr).length > 0) {
      for (const key in errorArr) {
        if (errorArr[key] === true) {
          errorKeys.push(key);
        }
      }

      if (errorKeys.length > 0) {
        let element = document?.getElementById(errorKeys[0]);
        element?.focus();
      }
    }
  }, [errorArr]);
  useEffect(() => {
    if (tableErrArr.length > 0) {
      let element = document?.getElementById(tableErrArr[0]);
      element?.focus();
    }
  }, [tableErrArr]);
  console.log(params, 'params');
  useEffect(() => {
    let id = 'partyName';
    if (params?.id) {
      getInvoiceMasterData(params?.id);
      setViewMode(params?.view);
    } else {
      setBackdropOpen(false);
    }
    if (!params?.id) {
      let element = document?.getElementById(id);
      element?.focus();
    }
    // dispatch(einvPreview(false));
  }, [params?.id]);
  const [promptInvoiceSetting, setpromptInvoiceSetting] = useState({
    open: false,
    later: false,
  });
  async function getLastSalesInvoice() {
    try {
      const res = await API.graphql(
        graphqlOperation(getMinMaxInvoiceDate, {
          serialnumber: data?.seriesVouchers?.value,
          invoicetypecd: 'Sales',
          invoiceid: params?.id && !isNaN(params?.id) ? params?.id : 0,
        })
      );
      let lastInvoiceDate = '';
      if (res?.data?.getMinMaxInvoiceDate !== null) {
        if (voucherFlag !== -1) {
          if (res?.data?.getMinMaxInvoiceDate?.previnvoicedate !== null) {
            setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.previnvoicedate);
            if (invoiceEntry?.invoiceid) {
              const lasteInvoiceDate = res?.data?.getMinMaxInvoiceDate?.previnvoicedate;
              const checkDateValid = await checkDateMyPostDate(lasteInvoiceDate, savedPostingDate);
              if (checkDateValid) {
                return;
              }
            }
          } else {
            if (invoiceEntry?.invoiceid) {
              const lasteInvoiceDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
              const checkDateValid = await checkDateMyPostDate(lasteInvoiceDate, savedPostingDate);
              if (checkDateValid) {
                return;
              }
            }
            setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
            if (params?.id === '' || isNaN(params?.id)) {
              if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
                setData((prev) => ({
                  ...prev,
                  invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                  // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                }));
                setInitialState((prev) => ({
                  ...prev,
                  invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                  // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                }));
              } else {
                if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
                  const currentPostingDate = moment(savedPostingDate * 1000).format('YYYY-MM-DD');
                  const opbDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate;

                  const selectedInvoiceDate =
                    currentPostingDate > opbDate ? savedPostingDate : res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
                  setData((prev) => ({
                    ...prev,
                    invoiceDate: selectedInvoiceDate,
                    // res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                    // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                  }));
                  setInitialState((prev) => ({
                    ...prev,
                    invoiceDate: selectedInvoiceDate,
                    //  res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                    // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                  }));
                }
              }
            }
          }
          if (res?.data?.getMinMaxInvoiceDate?.nextinvoicedate !== null) {
            setNextInvoiceDate(res?.data?.getMinMaxInvoiceDate?.nextinvoicedate);
          }
          if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
            lastInvoiceDate = res?.data?.getMinMaxInvoiceDate?.latestinvoicedate;
            setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.latestinvoicedate);
            if (params?.id === '' || isNaN(params?.id)) {
              const checkDateValid = await checkDateMyPostDate(lastInvoiceDate, savedPostingDate);
              if (checkDateValid) {
                return;
              }
            }
            if (params?.id === '' || isNaN(params?.id)) {
              if (res?.data?.getMinMaxInvoiceDate?.latestinvoicedate !== null) {
                setData((prev) => ({
                  ...prev,
                  invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                  // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                }));
                setInitialState((prev) => ({
                  ...prev,
                  invoiceDate: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                  // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.latestinvoicedate,
                }));
              } else {
                if (res?.data?.getMinMaxInvoiceDate?.openingbalancedate !== null) {
                  const currentPostingDate = moment(savedPostingDate * 1000).format('YYYY-MM-DD');
                  const opbDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate;

                  const selectedInvoiceDate =
                    currentPostingDate > opbDate ? savedPostingDate : res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
                  setData((prev) => ({
                    ...prev,
                    invoiceDate: selectedInvoiceDate,
                    //  res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                    // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                  }));
                  setInitialState((prev) => ({
                    ...prev,
                    invoiceDate: selectedInvoiceDate,
                    //  res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                    // dateOfDispatch: res?.data?.getMinMaxInvoiceDate?.openingbalancedate,
                  }));
                }
              }
            }
          } else {
            setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
          }
        } else {
          lastInvoiceDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
          setFirstInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
          setLastInvoiceDate(res?.data?.getMinMaxInvoiceDate?.openingbalancedate);
           if (params?.id === '' || isNaN(params?.id)) {
              const checkDateValid = await checkDateMyPostDate(lastInvoiceDate, savedPostingDate);
              if (checkDateValid) {
                return;
              }
            }else{
               if (invoiceEntry?.invoiceid) {
              const lasteInvoiceDate = res?.data?.getMinMaxInvoiceDate?.openingbalancedate;
              const checkDateValid = await checkDateMyPostDate(lasteInvoiceDate, savedPostingDate);
              if (checkDateValid) {
                return;
              }
            }
            }
        }
      }
      if (lastInvoiceDate === '') {
        const startDate = savedPostingDate
          ? moment(savedPostingDate * 1000).format('YYYY-MM-DD')
          : res?.data?.getMinMaxInvoiceDate?.openingbalancedate ??
            moment(userPreferece.financialYear.startdate * 1000).format('YYYY-MM-DD');
        if (InvoiceSettings?.defaultsetting == 1 && !params?.id) {
          setpromptInvoiceSetting((prev) => ({ ...prev, open: true }));
        }
        if (params?.id && !isNaN(params.id)) {
          if (invoiceEntry && Object.keys(invoiceEntry).length > 0) {
            setData((prev) => ({
              ...prev,
              invoiceDate: startDate,
            }));
            setInitialState((prev) => ({
              ...prev,
              invoiceDate: startDate,
            }));
          }
        } else {
          setData((prev) => ({
            ...prev,
            invoiceDate: startDate,
          }));
          setInitialState((prev) => ({
            ...prev,
            invoiceDate: startDate,
          }));
        }
      }
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
    }
  }
  async function print(htmlOnly) {
    let dataP = {
      items,
      nonItems,
      InvoiceSettings,
      companyDetails: companyData,
      data,
      partyDetails: partyBillAddressEntity,

      registrationType,
      totGST: totGST,
      totGstCess: totGSTCess,
      totNetAmount: netAmountToPay,
      totTaxableAmount: totTaxAmt,
      totAmount: totAmt,
      tabelTotAmount: totAmt,
      nonItemwiseTableAmount: totNetAmt,

      totDiscount: totDiscount,
      units,
      billingAddressDetails,
      deliveryAddressDetails,
      stateName: billingAddressDetails.stateCD,
      countryName: billingAddressDetails.countryCD,
      stateOfSupply: billingAddressDetails.districtCD,
      companyState: companyState,
      ewayBillNo: data.ewayBillNo,
      dateOfDispatch: data.dateOfDispatch,
      transportMode: data.transportMode,
      vehicleNumber: data.vehicleNumber,
    };
    let html = await SalesTaxablePrint(dataP);
    console.log('previewwww out');
    console.log(data, 'data out');

    if (htmlOnly) {
      return html;
    } else {
      let p = printJS({
        printable: html,
        type: 'raw-html',
        documentTitle: '',
      });
    }
  }

  const callBackNavigate = () => (isVoucher ? isVoucher(false) : navigate('/salesInvoiceReport'));
  let prev = useSelector((state) => state.eInvReducer);
  const ids = [
    'partyCreationModal',
    'addItemModal',
    'deleteCategory',
    'AddLedger',
    'AddHSNModal',
    'AddTdsTcsOptions',
    'BillingAddressModal',
    'DeliveryAddressModal',
    'SettingsModal',
  ];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);
  useEffect(() => {
    if (!InvoiceFetching) {
        if(voucherFlag===-1){
          getLastSalesInvoice();
        }else{
          if(data?.seriesVouchers?.value)
           getLastSalesInvoice();
        }
        
      
    }
  }, [InvoiceFetching, getCompany, voucherFlag, data?.seriesVouchers?.value, savedPostingDate]);
  useEffect(() => {
    if (currentPostingDate) {
      setSavedPostingDate(currentPostingDate);
    }
  }, [currentPostingDate]);

  useSaveShortcut(
    params?.id && params?.view !== true
      ? () => {
          if (prev.preview === false) {
            if (!anyElementExists()) saveEditChanges();
          }
        }
      : params?.view !== true
      ? () => {
          if (!anyElementExists()) saveChanges({ new: false });
        }
      : undefined
  );
  function checkDateMyPostDate(lastInvoiceDate, savedPostingDate) {
    let valid = false;
    const fyStart = userPreferece?.financialYear?.startdate;
    if (!fyStart) return;
    const fyStartMoment =
      typeof fyStart === 'number'
        ? moment.unix(fyStart).startOf('day')
        : moment(fyStart, ['YYYY-MM-DD', moment.ISO_8601], true).startOf('day');

    const lastInvoiceMoment =
      typeof lastInvoiceDate === 'number'
        ? moment.unix(lastInvoiceDate).startOf('day')
        : moment(lastInvoiceDate, ['YYYY-MM-DD', moment.ISO_8601], true).startOf('day');

    const savedPostingMoment =
      typeof savedPostingDate === 'number'
        ? moment.unix(savedPostingDate).startOf('day')
        : moment(savedPostingDate, ['YYYY-MM-DD', moment.ISO_8601], true).startOf('day');
    const computedMinDate = lastInvoiceMoment.isValid() ? lastInvoiceMoment : fyStartMoment;

    if (!computedMinDate.isValid() || !savedPostingMoment.isValid()) return;
    if (savedPostingMoment.isBefore(computedMinDate, 'day')) {
      // showWarningSnackbar(
      //   "'My Posting Date' does not apply to this form because it is earlier than the last invoiced date."
      // );
      valid = false;
    } else {
      const formattedDate = savedPostingMoment.format('YYYY-MM-DD');
      setInitialState((prev) => ({
        ...prev,
        invoiceDate: formattedDate,
      }));
      setData((prev) => ({
        ...prev,
        invoiceDate: formattedDate,
      }));
      valid = true;
    }

    return valid;
  }

  return (
    <Box className="PageHeight">
      {viewMode === true && invoiceEntry?.cancelflag ? (
        <>
          <Box
            sx={{
              position: 'sticky',
              top: '10px',
              borderRadius: '8px',
              marginBottom: '0px',
              padding: { xs: '10px 0px', sm: '10px 10px' },
              transition: 'all 1s ease-in-out',
            }}
          >
            <Alert
              variant="standard"
              sx={{
                color: invoiceEntry?.cancelflag === 0 ? '' : 'red',
                boxShadow: 'none',
                width: 450,
              }}
              severity="error"
            >
              {invoiceEntry?.cancelflag === 1 ? 'Sales Invoice cancelled. No further updates can be made.' : null}
            </Alert>
          </Box>
          <Box sx={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '10' }}>
            <CancelUI />
          </Box>
        </>
      ) : null}
      <Box
        className="darkDisabledInputs"
        sx={{
          opacity: viewMode === true && invoiceEntry?.cancelflag ? '0.5' : '1',
          cursor: viewMode === true && invoiceEntry?.cancelflag ? 'no-drop' : 'default',
        }}
      >
        <Box
          className={viewMode === true ? 'disable-interactions' : ''}
          sx={{
            borderRadius: '8px',
            ':hover': {
              boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
            },
            transition: 'all 1s ease-in-out',
          }}
        >
          <InvoiceBasicDetails
            todayDate={todayDate}
            moment={moment}
            accountDetails={accountDetails}
            invoiceLabels={{
              partyName: 'Customer Name',
              gstINName: 'Customer GSTIN',
              seriesName: 'Invoice Series Name',
              voucherName:Number(generalSettingsFlag)===-1?([2,3,5]?.includes(data?.taxability?.value)?'BOS Invoice No':'Tax Invoice No'):(data?.seriesVouchers?.serialflag===1?'BOS Invoice No':'Tax Invoice No') ,
              // 'Invoice Number',
              voucherValue: 'voucherNumber',
              dateName: 'Invoice Date',
              seriesValue: 'seriesVouchers',
              voucherType: 'SalesInvoice',
              orderNumberName: 'Customer Order Number',
              voucherModalName: 'Sales Invoice Number Settings',
              orderDateName: 'Customer Order Date',
            }}
            partyTypeCD={'CUSTOMER'}
            params={params}
            Type="Sales"
          />
        </Box>

        <Box
          sx={{
            width: '100%',
            // borderRadius: "12px",
            overflow: 'hidden',
            // marginBottom: "10px",
            mt: 3,
            // marginLeft:"0px",
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
            '.MuiTableCell-root': {
              padding: '0px 5px',
            },
            '.MuiTableCell-head': {
              borderBottom: '0px',
              fontWeight: 'bold',
            },
          }}
        >
          <Box sx={{ m: 2, mt: 0, mb: 0, ml: 0 }} className="custom-disabled">
            <EntryTable
              Type="Sales"
              params={params}
              invoiceLabels={{
                partyName: 'Customer Name',
                gstINName: 'Customer GSTIN',
                seriesName: 'Invoice Series Name',
                voucherName: 'Invoice Number',
                voucherValue: 'voucherNumber',
                dateName: 'Invoice Date',
                seriesValue: 'seriesVouchers',
                voucherType: 'SalesInvoice',
                orderNumberName: 'Customer Order Number',
                voucherModalName: 'Sales Invoice Number Settings',
                orderDateName: 'Customer Order Date',
              }}
              labelNamesOfTcs={{
                tdsOrTcsType: '2',
                amountName: 'Invoice Amount',
                tcsOrTdsName: 'Add TCS if any',
                tcsOrTdsLabel: 'TCS Section',
                tcsOrTdsAmountLabel: 'TCS (%)',
                amountAfterLabel: 'Amount(After TCS)',
              }}
              labelNamesOfTds={{
                tdsOrTcsType: '1',
                amountName: 'Invoice Amount',
                tcsOrTdsName: 'Add TDS if any',
                tcsOrTdsLabel: 'TDS Section',
                tcsOrTdsAmountLabel: 'TDS (%)',
                amountAfterLabel: 'Amount(After TDS)',
              }}
            />
          </Box>
        </Box>
        <Box
          className="custom-scrollbar"
          sx={{
            width: '100%',
            // borderRadius: "12px",
            overflow: { xs: 'scroll', lg: 'hidden' },
            // marginBottom: "10px",
            mt: 3,
            border: { xs: 'none', lg: '1px solid gray' },
            borderColor: 'input.label',
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
            '.MuiTableCell-root': {
              padding: '4px 10px',
            },
            '.MuiTableCell-head': {
              backgroundColor: 'background.tablebg',
              padding: '10px 8px',
              borderBottom: '0px',
              fontSize: '13px',
              fontWeight: 'bold',
            },
          }}
        >
          <Box
            className="custom-scrollbar"
            sx={{
              // m: 1,
              //  m: 2 , mt:0, mb:0,
              display: 'flex',
              // flexWrap: { xs: 'wrap', md: 'wrap' },
              flexDirection: { xs: 'column', lg: 'row' },
              overflow: 'scroll',
            }}
          >
            <HsnandJournalTab Type="Sales" />
            <Box
              sx={{
                flex: { xs: 1, lg: 0.5 },
                // m: "5px",
                // border: "1px solid #C9C9C9",
                // borderColor: "input.label",
                height: 290,
                p: '5px',
                overflowX: 'none',
                border: { xs: 'solid 1px gray', lg: 'none' },
                borderLeft: { lg: '1px solid gray' },
                marginTop: '10px',
              }}
            >
              <TotalAmountLabels
                params={params}
                labelNamesOfTcs={{
                  tdsOrTcsType: '2',
                  amountName: 'Invoice Amount',
                  tcsOrTdsName: 'Add TCS if any',
                  tcsOrTdsLabel: 'TCS Section',
                  tcsOrTdsAmountLabel: 'TCS (%)',
                  amountAfterLabel: 'Amount(After TCS)',
                }}
                labelNamesOfTds={{
                  tdsOrTcsType: '1',
                  amountName: 'Invoice Amount',
                  tcsOrTdsName: 'Add TDS if any',
                  tcsOrTdsLabel: 'TDS Section',
                  tcsOrTdsAmountLabel: 'TDS (%)',
                  amountAfterLabel: 'Amount(After TDS)',
                }}
                Type="Sales"
              />
            </Box>
          </Box>
        </Box>
        {/* <Box
        sx={{
          marginBottom: "10px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <PaymentDetails
          Enable_CreditPeriod={Enable_CreditPeriod}
          todayDate={todayDate}
          moment={moment}
          paymentType={"Receipt Details"}
          paymentLabels={{
            seriesName: "Receipt Series Name",
            voucherName:
              data.paymentType == "Cash"
                ? "Cash Receipt Number"
                : "Bank Receipt Number",
            voucherValue: "transactionVoucher",
            seriesValue: "transactionSeries",
            voucherType: "Receipt",
            accLabel: "Received To Account (Dr)",
            accNames: "Received To Account",
            amountName: "Received Amount",
            dueDateName: "Invoice Due Date",
            voucherModalName: "Receipt Number Settings",
          }}
          Type="Sales"
          params={params}
        />
      </Box> */}
        <Box
          sx={{
            // marginBottom: "10px",
            mt: 3,
            padding: { xs: '10px 0px', sm: '0px 0px' },
            borderRadius: '12px',
            // boxShadow:
            //   "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            // ":hover": {
            //   boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            // },
            transition: 'all 1s ease-in-out',
          }}
        >
          <DispatchDetails Type="Sales" />
        </Box>
        <Grid lg={12} sx={{ marginTop: '24px' }}>
          <Box
            sx={{
              padding: { xs: '10px 0px', sm: '0px 0px' },
              gap: '15px',
              display: 'flex',
              flexDirection: { xs: 'column', md: 'column', lg: 'row' },
            }}
          >
            <Grid
              item
              container
              lg={3}
              xs={12}
              md={12}
              sx={{
                padding: '0px 0px',
                display: 'flex',
                flexDirection: 'column',
                '.MuiPaper-root': {
                  boxShadow: 'none',
                },
              }}
            >
              <Description labelName="Invoice Description" Type="Sales" />
            </Grid>
            {/* <Grid item container lg={9} xs={12} md={12}> */}
            <MultiFileAttachment Type="Sales" />
            {/* </Grid> */}
          </Box>
        </Grid>
      </Box>
      {console.log(invoiceEntry, 'invoiceEntry')}
      {/* {(viewMode == true ? invoiceEntry.cancelflag === 0 : true) ? ( */}
      <DraggableAction
        actionType={params?.id && params?.view !== true ? 'edit' : invoiceEntry?.cancelflag === 1 ? 'cancelled' : 'save'}
        from={'sales'}
        onExit={() => {
          navigate('/salesInvoiceReport');
        }}
        onSave={
          params?.id && params?.view !== true
            ? () => {
                saveEditChanges();
              }
            : params?.view !== true
            ? () => saveChanges({ new: false })
            : null
        }
        onEnableEdit={() => {
          navigate('/editnewinvoicetax', {
            state: { id: invoiceEntry?.invoiceid,cessexist:invoiceEntry?.cessexist },
          });
        }}
        onPrint={params?.view == true || params?.id ? () => fetchAndPrintPDF(uri) : null}
        onCancel={
          params?.id && invoiceEntry?.irn && !invoiceEntry.is_cancelled
            ? () => showWarningSnackbar('Please cancel the E-Invoice before cancelling the Sales Invoice.')
            : () => {
                setCancelModalStatus(true);
                setItemData({
                  id: invoiceEntry?.invoiceid,
                  nav: '/salesInvoiceReport',
                  todo: 'cancel',
                  linked: paymentTransID !== '',

                  from: 'sales',
                });
              }
          // : null
        }
        onDelete={
          params?.id && invoiceEntry?.irn && !invoiceEntry.is_cancelled
            ? () => showWarningSnackbar('Please cancel the E-Invoice before cancelling the Sales Invoice.')
            : params?.id
            ? () => {
                setDeleteModalStatus(true);
                setItemData({
                  id: invoiceEntry?.invoiceid,
                  nav: '/salesInvoiceReport',
                  todo: 'delete',
                  linked: paymentTransID !== '',

                  from: 'sales',
                });
              }
            : null
        }
        onEInvoice={
          params?.view === true && getCompany.relatedcompanydetailsnew[0].einvoiceflag == 1 && !params?.irn && data.partyCategory !== 'UB'
            ? async () => {
                setConnectCheckbox('invoice');
                if (getCompany.relatedcompanydetailsnew[0].einvoiceconnect === 0) {
                  // setAuthInv(true);
                  setEInvAuthModalProps((prev) => ({ ...prev, open: true }));
                  setEImp(true);
                  // setPreviewSalesTaxableModal(false);
                } else {
                  setEImp(true);
                  // setPreviewSalesTaxableModal(true);
                  // dispatch(einvPreview({ preview: true, id: 0 }));
                  if (modalRef.current) {
                    setBackdropOpen(true);
                    modalRef.current.triggerCustomAction(invoiceEntry?.invoiceid);
                    setBackdropOpen(false);
                  }
                }
              }
            : null
        }
        onPreview={
          // (params?.view == true || Number.isNaN(params?.id)) && data.partyName.label !== ''
          //   ? () => {
          //       setPreviewSalesTaxableModal(true);
          //     }
          //   : null
          () => {
            setPreviewSalesTaxableModal(true);
          }
        }
        onSaveNew={params?.view !== true ? () => saveChanges({ new: true }) : null}
        onReset={
          params?.view !== true
            ? async () => {
                if (params?.id) {
                  setData(initialState);
                  setItems(initItemTableDta.length > 0 ? initItemTableDta : [newItemObj]);
                  setNonItems(initNonItemTableData.length > 0 ? initNonItemTableData : [newNonItemObj]);
                  setItemsRows(initialAttachments);
                } else {
                  setBackdropOpen(true);
                  // setData((prevData) => ({
                  // ...resetData, // Reset all fields
                  //   transactionVoucher: prevData?.transactionVoucher,
                  //   voucherNumber: prevData?.voucherNumber, // Preserve voucherNumber
                  //   placeOfSupply: prevData?.placeOfSupply, // Preserve placeOfSupply
                  //   seriesVouchers: prevData?.seriesVouchers,
                  //   transactionSeries: prevData?.transactionSeries,
                  //   invoiceDate: prevData?.invoiceDate,
                  //   customerOrderDate: prevData?.customerOrderDate,
                  //
                  // }));
                  setData(initialState);
                  setNonItems([resetNonItems]);
                  setItems([resetItems]);
                  setItemsRows([]);
                  setItemValid(true);
                  setNonItemValid(true);
                  await getLastSalesInvoice();
                  setBackdropOpen(false);
                }
              }
            : null
        }
      />
      {/* ) : null} */}
      {cancelModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={cancelModalStatus}
          setOpen={setCancelModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          actionType={'Cancel'}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          invTransArr={invTransArr}
          paymentTransArr={paymentTransArr}
          netAmountToPay={netAmountToPay}
          companyState={companyState}
          Type={'Sales'}
          path={url}
        />
      ) : null}
      {deleteModalStatus == true ? (
        <InvoiceCancel
          state={state}
          setState={setState}
          open={deleteModalStatus}
          setOpen={setDeleteModalStatus}
          itemData={itemData}
          data={data}
          setData={setData}
          invoiceEntry={invoiceEntry}
          transID={paymentTransID}
          actionType={'Delete'}
          Type={'Sales'}
          path={url}
        />
      ) : null}
      <ConfirmCancel open={cancelModal} setOpen={setCancelModal} path="salesInvoiceReport" />

      {shareOpen && (
        <ShareModal
          open={shareOpen}
          emailData={{
            selectedRow: selected?.map((inv) => ({
              id: Number(inv.invoiceid),
              recipientId: Number(inv.PartyID),
              email: inv.Email,
              name: inv.PartyDisplayName,
              invoiceNumber: inv.voucherNumber,
            })),
            type: 'salesInvoice',
          }}
          progress={progress}
          onClose={callBackNavigate}
        />
      )}
      <EInvAuth
        open={eInvAuthModalProps.open}
        setOpen={(val) => {
          setEInvAuthModalProps((prev) => ({ ...prev, open: val }));
        }}
        action={(test) => {
          if (test === 'success' && location.pathname.includes('viewnewinvoicetax')) {
            setBackdropOpen(true);
            modalRef.current.triggerCustomAction(invID || invoiceEntry?.invoiceid);
            setBackdropOpen(false);

            // setPreviewSalesTaxableModal(true);
          }
        }}
        checkbox={connectCheckbox}
        allSales={true}
        setBackdropOpen={setBackdropOpen}
        onComplete={eInvAuthModalProps.onComplete}
      />
      <Loader open={backdropOpen} />
      <PreviewSalesTaxable
        id={invID || invoiceEntry?.invoiceid || prev?.id}
        open={previewSalesTaxableModal}
        eImp={eImp}
        taxability={data?.taxability?.value}
        setBackdropOpen={setBackdropOpen}
        setInvData={setData}
        resetData={resetData}
        setItems={setItems}
        resetItems={resetItems}
        resetNonItems={resetNonItems}
        setItemValid={setItemValid}
        setNonItemValid={setNonItemValid}
        setItemsRows={setItemsRows}
        eWayImp={eWayImp}
        setNonItems={setNonItems}
        getLastSalesInvoice={getLastSalesInvoice}
        getInvoice={() => getInvoiceMasterData(invID)}
        setOpen={setPreviewSalesTaxableModal}
        saveNew={saveNew}
        getHtml={print}
        ref={modalRef}
        path={path}
        setInvID={setInvID}
        setEImp={setEImp}
        share={() => setShareOpen(path + `Invoices/Ledgerx_Sales_Invoice${data?.voucherNumber}.pdf`, true)}
      />
      {console.log(params, 'params')}
      {/* <AddNewEwayModal open={eWayOpen} setOpen={setEwayOpen} invID={invID} /> */}
      <PromptInvoiceSettings
        open={promptInvoiceSetting.open && promptInvoiceSetting.later === false}
        onClick={() => {
          navigate('/invoiceSettings', {
            state: { title: 'sales' },
          });
        }}
        onClose={() => setpromptInvoiceSetting(() => ({ open: false, later: true }))}
      />
    </Box>
  );
}

export default NewSalesInvoiceTaxPrime;
